<template>
	<div class="content">
		<div v-if="isPdfLoading" class="pdf-loading-overlay">
			<div class="pdf-loading-spinner">
				<div class="pdf-loading-text">{{ pdfLoadingMsg || 'PDF 생성 중...' }}</div>
				<div v-if="pdfLoadingTotal > 0" class="pdf-loading-bar-wrap">
					<div class="pdf-loading-bar" :style="{ width: (pdfLoadingCurrent / pdfLoadingTotal * 100) + '%' }"></div>
				</div>
			</div>
		</div>
		<div v-if="loadSt" class="print-wrap">
			<div class="print-left">
				<div class="section-tit">슬라이드 선택/제외</div>
				<div class="table-wrap">
					<table class="table">
						<tr>
							<th>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opAll" @change="setAllCheck" />
									<span class="checkbox"></span>
								</label>
							</th>
							<th>구분</th>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[0]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>INTRO</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[1]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>비교</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[2]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>물건개요</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[3]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>임대정보</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[4]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>건축물정보</td>
						</tr>
						<tr><td><label class="input-checkbox"><input type="checkbox" v-model="invShow" @change="onInvestmentToggle" /><span class="checkbox"></span></label></td><td>투자분석</td></tr>
						<tr><td><label class="input-checkbox"><input type="checkbox" v-model="devShow" @change="onInvestmentToggle" /><span class="checkbox"></span></label></td><td>리모델링/신축</td></tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[5]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>건축 내/외부 사진</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[6]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>지도</td>
						</tr>
					</table>
				</div>
				<div class="section-tit mt-4 select">
					사진 선택/제외
					<select class="form-control select sm" v-model="isBid">
						<option v-for="i in bidList" :key="'ooopp_' + i" :value="i">{{ itemList[i].item.building_name }}</option>
					</select>
				</div>
				<ul class="table-list">
					<li class="table-list--item" v-for="(op, idx) in itemList[isBid].item.imgObjList" :key="'opp_' + idx">
						<div class="check">
							<label class="input-checkbox">
								<input type="checkbox" v-model="op.st" @change="updateId" :disabled="!opList[4]" />
								<span class="checkbox"></span>
							</label>
						</div>
						<div class="name">{{ op.name }}</div>
					</li>
				</ul>
				<div class="section-tit mt-4" v-if="itemList[isBid] && itemList[isBid].estimate.available">블록 AI추정가 ({{ itemList[isBid].item.building_name }})</div>
				<div class="estimate-control no-print" v-if="itemList[isBid] && itemList[isBid].estimate.available">
					<label class="input-checkbox">
						<input type="checkbox" v-model="itemList[isBid].showEstimate" />
						<span class="checkbox"></span>
						<span class="ms-2">블록 AI추정가 표시</span>
					</label>
					<div class="estimate-edit" v-if="itemList[isBid].showEstimate">
						<label>총액(만원)<input type="number" class="form-control form-control-sm" v-model.number="itemList[isBid].estimate.total" @change="syncEstimatePyFromTotal(isBid)" /></label>
						<label>평당(만원)<input type="number" class="form-control form-control-sm" v-model.number="itemList[isBid].estimate.py" @change="syncEstimateTotalFromPy(isBid)" /></label>
					</div>
				</div>
				<InvestmentSidebarEditor
					v-if="itemList[isBid] && itemList[isBid].invState"
					:state="itemList[isBid].invState"
					:residential="invResidentialOf(isBid)"
					@change="onInvestmentEdit" />
				<SlideEditor
					v-if="itemList[isBid] && itemList[isBid].invState"
					:slides="itemList[isBid].slides"
					:uploading="slideUploading"
					@change="onSlideChange"
					@add-photo="onSelectedAddPhoto"
					@add-blank="onSelectedAddBlank" />
				<!-- <img :src="this.img" /> -->
				<div class="cover-variant-picker no-print">
					<span class="label">표지 스타일</span>
					<label v-for="v in coverVariants" :key="v.id">
						<input type="radio" :value="v.id" v-model="coverVariant" />
						<span>{{ v.label }}</span>
					</label>
				</div>
				<div class="btn-wrap">
					<button type="button" class="btn btn-sm btn-secondary" @click="copyChartImg">출력</button>
				</div>
			</div>
			<div class="print-right" :style="watermarkStyle">
				<!-- 1. 인트로 (표지 3 variant) — 배치 출력 공통 표지. 타이틀은 '매입 제안서' 고정. -->
				<div
					v-if="opList[0]"
					id="capture_1"
					name="capture"
					class="print-section cover"
					:class="['cover-' + coverVariant, cobrandClass]"
				>
					<!-- Variant 01 Editorial: 단일 near-white 캔버스 + 우측 inset 사진 박스 + 상단 전폭 라인 + 하단 라인 2-split -->
					<template v-if="coverVariant === '01'">
						<div class="cover-paper"></div>
						<span class="cover-caption">PROPERTY OVERVIEW</span>
						<span class="cover-top-line"></span>
						<span class="cover-vstripe"></span>
						<div class="cover-photo-box">
							<img v-if="coverImgFirst" :src="coverImgFirst" alt="" class="cover-photo" />
						</div>
						<h1 class="cover-title">매입 제안서</h1>
						<div class="cover-addr-pill">{{ coverAddrFirst }}</div>
						<span class="cover-bottom-line-l"></span>
						<div class="cover-wordmark"></div>
						<span class="cover-bottom-line-r"></span>
						<div class="cover-disclaimer">{{ disclaimerText }}</div>
					</template>

					<!-- Variant 02 Bold Burgundy: cream 상단 + full-burgundy 본문 + cream 하단 -->
					<template v-else-if="coverVariant === '02'">
						<div class="cover-top-strip">
							<span class="cover-caption">PROPERTY OVERVIEW</span>
						</div>
						<div class="cover-main">
							<div class="cover-paper"></div>
							<span class="cover-vdecor-w1"></span>
							<span class="cover-vdecor-dark"></span>
							<span class="cover-vdecor-w2"></span>
							<div class="cover-photo-box">
								<img v-if="coverImgFirst" :src="coverImgFirst" alt="" class="cover-photo" />
							</div>
							<h1 class="cover-title">매입 제안서</h1>
							<div class="cover-addr">{{ coverAddrFirst }}</div>
							<span class="cover-bottom-line-l"></span>
							<div class="cover-wordmark"></div>
							<span class="cover-bottom-line-r"></span>
						</div>
						<div class="cover-bottom-strip">
							<div class="cover-disclaimer">{{ disclaimerText }}</div>
						</div>
					</template>

					<!-- Variant 05 Boutique Advisory: 플랫 burgundy + 상단 darker band + 좌 카드 + 하단 cream strip -->
					<template v-else-if="coverVariant === '05'">
						<div class="cover-top-band"></div>
						<div class="cover-bg">
							<img v-if="coverImgFirst" :src="coverImgFirst" alt="" class="cover-photo" />
							<div class="cover-bg-tint"></div>
							<div class="cover-bg-scrim"></div>
						</div>
						<div class="cover-cream-band">
							<div class="cover-disclaimer">{{ disclaimerText }}</div>
						</div>
						<div class="cover-top-outer">
							<div class="cover-top-row">
								<span class="cover-caption">PROPERTY OVERVIEW</span>
								<div class="cover-wordmark cover-wordmark--top"></div>
							</div>
							<span class="cover-top-line"></span>
						</div>
						<div class="cover-card">
							<h1 class="cover-title">매입 제안서</h1>
							<div class="cover-addr">
								<svg class="pin-icon" width="10" height="14" viewBox="0 0 10 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M5 0C2.24 0 0 2.24 0 5c0 3.75 5 9 5 9s5-5.25 5-9c0-2.76-2.24-5-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>
								<span>{{ coverAddrFirst }}</span>
							</div>
							<div class="cover-card-footer">
								<div class="cover-wordmark"></div>
								<span class="cover-card-divider"></span>
							</div>
						</div>
					</template>

					<!-- Variant 00 Classic: 구버전 표지 (common.scss `.print-section.cover` 글로벌 스타일 사용) -->
					<template v-else>
						<div class="tit">
							<div class="middle">매입 제안서</div>
							<div class="bottom">{{ coverAddrFirst }}</div>
						</div>
						<div class="logo"></div>
					</template>
				</div>
				<template v-if="opList[1]">
					<div
						v-for="(ilist, idx) in itemGroup"
						name="capture"
						:id="'capture_' + idx"
						:key="'capture_' + idx"
						class="print-section flex2-1"
					>
						<div class="print-tit">COMPARABLE(비교)</div>
						<div class="left">
							<div class="table-wrap">
								<table class="table type-input">
									<colgroup>
										<col width="25%" />
										<col width="25%" />
										<col width="25%" />
										<col width="25%" />
									</colgroup>
									<tr>
										<th>빌딩명</th>
										<th>{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.building_name : '' }}</th>
										<th>{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.building_name : '' }}</th>
										<th>{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.building_name : '' }}</th>
									</tr>
									<tr>
										<th>사진</th>
										<td class="img">
											<img :src="ilist.idList[0] ? itemList[ilist.idList[0]].item.img : null" />
										</td>
										<td class="img">
											<img :src="ilist.idList[1] ? itemList[ilist.idList[1]].item.img : null" />
										</td>
										<td class="img">
											<img :src="ilist.idList[2] ? itemList[ilist.idList[2]].item.img : null" />
										</td>
									</tr>
									<tr>
										<th class="txt-c--red">소재지</th>
										<td class="txt-c--red">{{ ilist.idList[0] ? itemList[ilist.idList[0]].coverAddr : '' }}</td>
										<td class="txt-c--red">{{ ilist.idList[1] ? itemList[ilist.idList[1]].coverAddr : '' }}</td>
										<td class="txt-c--red">{{ ilist.idList[2] ? itemList[ilist.idList[2]].coverAddr : '' }}</td>
									</tr>
									<tr>
										<th class="txt-c--red">매매금액</th>
										<td class="txt-c--red">
											{{
												ilist.idList[0]
													? $formatMoney(itemList[ilist.idList[0]].item.sell_price, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[1]
													? $formatMoney(itemList[ilist.idList[1]].item.sell_price, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[2]
													? $formatMoney(itemList[ilist.idList[2]].item.sell_price, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th class="txt-c--red">대지면적</th>

										<td class="txt-c--red">
											{{
												ilist.idList[0]
													? $formatArea(itemList[ilist.idList[0]].item.land_size_m2) + '㎡(' + $formatArea(itemList[ilist.idList[0]].item.land_size_p) + '평)'
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[1]
													? $formatArea(itemList[ilist.idList[1]].item.land_size_m2) + '㎡(' + $formatArea(itemList[ilist.idList[1]].item.land_size_p) + '평)'
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[2]
													? $formatArea(itemList[ilist.idList[2]].item.land_size_m2) + '㎡(' + $formatArea(itemList[ilist.idList[2]].item.land_size_p) + '평)'
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>연면적</th>
										<td>
											{{
												ilist.idList[0]
													? $formatArea(itemList[ilist.idList[0]].item.total_size_m2) + '㎡(' + $formatArea(itemList[ilist.idList[0]].item.total_size_p) + '평)'
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[1]
													? $formatArea(itemList[ilist.idList[1]].item.total_size_m2) + '㎡(' + $formatArea(itemList[ilist.idList[1]].item.total_size_p) + '평)'
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[2]
													? $formatArea(itemList[ilist.idList[2]].item.total_size_m2) + '㎡(' + $formatArea(itemList[ilist.idList[2]].item.total_size_p) + '평)'
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>건축면적</th>
										<td>
											{{
												ilist.idList[0]
													? $formatArea(itemList[ilist.idList[0]].item.build_size_m2) + '㎡(' + $formatArea(itemList[ilist.idList[0]].item.build_size_p) + '평)'
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[1]
													? $formatArea(itemList[ilist.idList[1]].item.build_size_m2) + '㎡(' + $formatArea(itemList[ilist.idList[1]].item.build_size_p) + '평)'
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[2]
													? $formatArea(itemList[ilist.idList[2]].item.build_size_m2) + '㎡(' + $formatArea(itemList[ilist.idList[2]].item.build_size_p) + '평)'
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th class="txt-c--red">평단가</th>
										<td class="txt-c--red">
											{{
												ilist.idList[0]
													? $formatNumber(itemList[ilist.idList[0]].item.land_size_py_price) + '만원'
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[1]
													? $formatNumber(itemList[ilist.idList[1]].item.land_size_py_price) + '만원'
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[2]
													? $formatNumber(itemList[ilist.idList[2]].item.land_size_py_price) + '만원'
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>용도지역</th>
										<td>{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.cfg_val1 : '' }}</td>
										<td>{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.cfg_val1 : '' }}</td>
										<td>{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.cfg_val1 : '' }}</td>
									</tr>
									<tr>
										<th>준공년도 /<br />리모델링</th>
										<td>
											{{ ilist.idList[0] ? $dateFormat2(itemList[ilist.idList[0]].item.build_date) : '' }}
											{{
												ilist.idList[0] && itemList[ilist.idList[0]].item.remodel_date
													? ' / ' + $dateFormat2(itemList[ilist.idList[0]].item.remodel_date)
													: ''
											}}
										</td>
										<td>
											{{ ilist.idList[1] ? $dateFormat2(itemList[ilist.idList[1]].item.build_date) : '' }}
											{{
												ilist.idList[1] && itemList[ilist.idList[1]].item.remodel_date
													? ' / ' + $dateFormat2(itemList[ilist.idList[1]].item.remodel_date)
													: ''
											}}
										</td>
										<td>
											{{ ilist.idList[2] ? $dateFormat2(itemList[ilist.idList[2]].item.build_date) : '' }}
											{{
												ilist.idList[2] && itemList[ilist.idList[2]].item.remodel_date
													? ' / ' + $dateFormat2(itemList[ilist.idList[2]].item.remodel_date)
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th class="txt-c--red">건페율/용적률</th>
										<td class="txt-c--red">
											{{
												ilist.idList[0]
													? $formatRatio(itemList[ilist.idList[0]].item.bl_ratio) +
													  '/' +
													  $formatRatio(itemList[ilist.idList[0]].item.fa_ratio)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[1]
													? $formatRatio(itemList[ilist.idList[1]].item.bl_ratio) +
													  '/' +
													  $formatRatio(itemList[ilist.idList[1]].item.fa_ratio)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[2]
													? $formatRatio(itemList[ilist.idList[2]].item.bl_ratio) +
													  '/' +
													  $formatRatio(itemList[ilist.idList[2]].item.fa_ratio)
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>규모</th>
										<td>
											{{
												ilist.idList[0]
													? $getFloorString(
															itemList[ilist.idList[0]].item.floor_cnt_B,
															itemList[ilist.idList[0]].item.floor_cnt_F,
													  )
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[1]
													? $getFloorString(
															itemList[ilist.idList[1]].item.floor_cnt_B,
															itemList[ilist.idList[1]].item.floor_cnt_F,
													  )
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[2]
													? $getFloorString(
															itemList[ilist.idList[2]].item.floor_cnt_B,
															itemList[ilist.idList[2]].item.floor_cnt_F,
													  )
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>주용도</th>
										<td>
											{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.main_purpose : '' }}
										</td>
										<td>
											{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.main_purpose : '' }}
										</td>
										<td>
											{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.main_purpose : '' }}
										</td>
									</tr>
									<tr>
										<th>엘리베이터</th>
										<td>
											{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.ev_cnt + '대' : '' }}
										</td>
										<td>
											{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.ev_cnt + '대' : '' }}
										</td>
										<td>
											{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.ev_cnt + '대' : '' }}
										</td>
									</tr>
									<tr>
										<th>주차대수</th>
										<td>
											{{
												ilist.idList[0]
													? itemList[ilist.idList[0]].item.park_type_name +
													  ' / 법정 ' +
													  itemList[ilist.idList[0]].item.park_cnt_law +
													  '대 / 실제 ' +
													  itemList[ilist.idList[0]].item.park_cnt_real +
													  '대'
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[1]
													? itemList[ilist.idList[1]].item.park_type_name +
													  ' / 법정 ' +
													  itemList[ilist.idList[1]].item.park_cnt_law +
													  '대 / 실제 ' +
													  itemList[ilist.idList[1]].item.park_cnt_real +
													  '대'
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[2]
													? itemList[ilist.idList[2]].item.park_type_name +
													  ' / 법정 ' +
													  itemList[ilist.idList[2]].item.park_cnt_law +
													  '대 / 실제 ' +
													  itemList[ilist.idList[2]].item.park_cnt_real +
													  '대'
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>역</th>
										<td>{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.substation : '' }}</td>
										<td>{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.substation : '' }}</td>
										<td>{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.substation : '' }}</td>
									</tr>
									<tr>
										<th>역과의 거리</th>
										<td>{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.substation_distance + 'm' : '' }}</td>
										<td>{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.substation_distance + 'm' : '' }}</td>
										<td>{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.substation_distance + 'm' : '' }}</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="right">
							<!-- <div class="section-tit">서울 강남구</div> -->
							<!-- <div class="section-tit"></div> -->
							<div class="map-wrap">
								<div :id="ilist.mapIdName"></div>
							</div>
							<div class="table-wrap">
								<div class="txt-right txt-size--sm mb-1 mt-1">단위:원</div>
								<table class="table type-input">
									<tr>
										<th>NO.</th>
										<th>빌딩이름</th>
										<th>금액(대지평당금액)</th>
										<th>대지평수/연면적</th>
										<th>임대료</th>
										<th>수익률</th>
									</tr>
									<tr v-for="(ii, idx) in ilist.idList" :key="'mta_idx_' + idx">
										<!-- itemList[ilist.idList[1]].item.land_size_m2 -->
										<td>0{{ idx + 1 }}</td>
										<td>
											{{ itemList[ilist.idList[idx]].item.building_name }}<br />
											{{
												$getFloorString(
													itemList[ilist.idList[idx]].item.floor_cnt_B,
													itemList[ilist.idList[idx]].item.floor_cnt_F,
												)
											}}
										</td>
										<td>
											{{ $formatMoney(itemList[ilist.idList[idx]].item.sell_price, $MONEY_FORMAT_TYPE.LOAN) }}<br />
											(평당
											{{
												$formatNumber(
													(
														itemList[ilist.idList[idx]].item.sell_price / itemList[ilist.idList[idx]].item.land_size_p
													).toFixed(2),
												)
											}}만원)
										</td>
										<td>
											{{ $formatArea(itemList[ilist.idList[idx]].item.land_size_p) }}평 /
											{{ $formatArea(itemList[ilist.idList[idx]].item.total_size_p) }}평
										</td>
										<td>{{ $formatNumber(itemList[ilist.idList[idx]].item.ex_sum_rent_money) }}만원</td>
										<td>{{ itemList[ilist.idList[idx]].item.earning_rate }}%</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="page-footer-disclaimer">
							<p>{{ pageFooterLine1 }}</p>
							<p>{{ pageFooterLine2 }}</p>
						</div>
					</div>
				</template>
				<template v-for="i in bidList" :key="'capture_item_x_' + i">
					<!-- 2. 물건개요 — dense-report 레이아웃 (버건디 메트릭바 + 2컬럼 테이블 + 우측 사진 + 특징) -->
					<div
						v-if="opList[2]"
						:id="'capture_item_2_' + i"
						:key="'capture_item_2_' + i"
						name="capture"
						class="print-section flex property-overview"
					>
							<div class="overview-header">
								<span class="overview-caption">PROPERTY OVERVIEW</span>
								<span class="overview-line"></span>
								<span class="overview-brand"></span>
							</div>

							<!-- 메인 콘텐츠: 좌측(Summary 절반 + 메트릭 + 테이블) + 우측(사진 Summary 시작점부터, contain 으로 안잘림) -->
							<div class="overview-main">
							<div class="overview-left">

							<div class="overview-title-band">
								<strong class="title-main">{{ itemList[i].item.building_name }}</strong>
								<span class="title-slash">/</span>
								<span class="title-addr">{{ itemList[i].bodyAddr }}</span>
							</div>

							<div class="metric-bar">
								<div class="metric">
									<div class="metric-label">매매금액</div>
									<div class="metric-value">{{ $formatMoney(itemList[i].item.sell_price, $MONEY_FORMAT_TYPE.LOAN) }}</div>
									<div class="metric-sub">평당 {{ $formatMoney((itemList[i].item.land_size_p ? Math.floor(itemList[i].item.sell_price / itemList[i].item.land_size_p) : 0), $MONEY_FORMAT_TYPE.LOAN) }}</div>
								</div>
								<div class="metric">
									<div class="metric-label">수익률</div>
									<div class="metric-value">{{ itemList[i].item.total_income_rate }}%</div>
									<div class="metric-sub">연간 기준</div>
								</div>
								<div class="metric">
									<div class="metric-label">연면적 / 대지면적</div>
									<div class="metric-value">{{ Math.round(Number(itemList[i].item.total_size_p) || 0).toLocaleString('ko-KR') }}평 / {{ Math.round(Number(itemList[i].item.land_size_p) || 0).toLocaleString('ko-KR') }}평</div>
									<div class="metric-sub">건폐 {{ $formatRatio(itemList[i].item.bl_ratio) }} / 용적 {{ $formatRatio(itemList[i].item.fa_ratio) }}</div>
								</div>
								<div class="metric">
									<div class="metric-label">주변역</div>
									<div class="metric-value">{{ itemList[i].item.substation || '-' }}</div>
									<div class="metric-sub"><template v-if="itemList[i].item.substation_distance">{{ itemList[i].item.substation_distance }}m</template></div>
								</div>
							</div>

							<!-- 본문 좌측 스택: 3개 테이블 세로 배치 (금액 → 토지 → 건축) -->
							<div class="body-stack">
								<div class="area-amt">

									<!-- 섹션 B: 금액정보 -->
								<div class="section-tit section-tit--print-header">금액정보</div>
								<div class="table-wrap">
									<table class="table text-left type-input compact">
										<colgroup>
											<col width="32%" />
											<col width="68%" />
										</colgroup>
										<tr>
											<th class="txt-c--red">매매금액</th>
											<td class="txt-c--red">
												<span class="float-start p-0">{{ $formatMoney(itemList[i].item.sell_price, $MONEY_FORMAT_TYPE.LOAN) }}</span>
												<span class="float-end p-0 txt-c--red">[평당:{{ $formatMoney((itemList[i].item.land_size_p ? Math.floor(itemList[i].item.sell_price / itemList[i].item.land_size_p) : 0), $MONEY_FORMAT_TYPE.LOAN) }}]<span v-if="estimateBadgeOf(i) && estimateBadgeOf(i).kind === 'under'" class="sell-compare"> · {{ estimateBadgeOf(i).comparePyText }}</span></span>
											</td>
										</tr>
										<tr v-if="itemList[i].showEstimate && itemList[i].estimate.available">
											<th>블록 AI추정가</th>
											<td>
												<span class="float-start p-0">{{ $formatMoney(itemList[i].estimate.total, $MONEY_FORMAT_TYPE.LOAN) }}<span v-if="estimateBadgeOf(i) && estimateBadgeOf(i).kind !== 'premium'" class="estimate-badge" :class="'estimate-badge--' + estimateBadgeOf(i).kind">{{ estimateBadgeOf(i).text }}</span></span>
												<span class="float-end p-0">[평당:{{ $formatMoney(itemList[i].estimate.py, $MONEY_FORMAT_TYPE.LOAN) }}]</span>
											</td>
										</tr>
										<tr v-if="estimateBadgeOf(i) && estimateBadgeOf(i).kind === 'premium'" class="estimate-note-row">
											<td colspan="2"><span class="note-badge">참고</span><span class="estimate-note-text-static">{{ estimateNoteText }}</span></td>
										</tr>
										<tr>
											<th>토지가격</th>
											<td>
												<span class="float-start p-0">{{
													$formatMoney(itemList[i].item.land_price, $MONEY_FORMAT_TYPE.LOAN)
												}}</span>
												<span class="float-end p-0 txt-c--red">
													[평당:{{ $formatMoney(itemList[i].item.land_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
												</span>
											</td>
										</tr>
										<tr>
											<th>건물가격</th>
											<td>
												<span class="float-start p-0">{{
													$formatMoney(itemList[i].item.building_price, $MONEY_FORMAT_TYPE.LOAN)
												}}</span>
												<span class="float-end p-0">
													[평당:{{ $formatMoney(itemList[i].item.building_price_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
												</span>
											</td>
										</tr>
										<tr>
											<th>연면적 평당가격</th>
											<td>{{ $formatMoney(itemList[i].item.total_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}</td>
										</tr>
										<tr>
											<th>보증금</th>
											<td>{{ $formatMoney(itemList[i].item.ex_sum_rent_deposit, $MONEY_FORMAT_TYPE.LOAN) }}</td>
										</tr>
										<tr>
											<th>월임대료</th>
											<td>{{ $formatMoney(itemList[i].item.ex_sum_rent_money, $MONEY_FORMAT_TYPE.LOAN) }}</td>
										</tr>
										<tr>
											<th>관리비</th>
											<td>{{ itemList[i].item.ex_sum_mgr_fee ? $formatMoney(itemList[i].item.ex_sum_mgr_fee, $MONEY_FORMAT_TYPE.LOAN) : '-' }}</td>
										</tr>
										<tr>
											<th>총수익</th>
											<td>{{ (itemList[i].item.total_income !== '' && itemList[i].item.total_income !== null && Number.isFinite(Number(itemList[i].item.total_income))) ? $formatMoney(itemList[i].item.total_income, $MONEY_FORMAT_TYPE.LOAN) : '-' }}</td>
										</tr>
										<tr>
											<th class="txt-c--red">수익률</th>
											<td class="txt-c--red">{{ itemList[i].item.total_income_rate }}%</td>
										</tr>
									</table>
								</div>
								</div>
								<div class="area-land">

								<!-- 섹션 C: 토지정보 -->
								<div class="section-tit section-tit--print-header">토지정보</div>
								<div class="table-wrap">
									<table class="table text-left type-input compact">
										<colgroup>
											<col width="32%" />
											<col width="68%" />
										</colgroup>
										<tr>
											<th class="txt-c--red">대지면적</th>
											<td class="txt-c--red">
												<span class="float-start p-0">{{ $formatArea(itemList[i].item.land_size_m2) }}㎡({{ $formatArea(itemList[i].item.land_size_p) }}평)</span>
												<span class="float-end p-0">
													[평당:{{ $formatMoney(itemList[i].item.land_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
												</span>
											</td>
										</tr>
										<tr>
											<th>용도지역</th>
											<td>{{ itemList[i].item.cfg_val1 }}</td>
										</tr>
										<tr>
											<th>주변역/거리</th>
											<td>{{ itemList[i].item.substation }} <template v-if="itemList[i].item.substation_distance">[{{ itemList[i].item.substation_distance }}m]</template></td>
										</tr>
										<tr>
											<th>공시지가/합계</th>
											<td>
												<span class="float-start p-0">
													{{ $formatMoney(itemList[i].item.public_land_price, $MONEY_FORMAT_TYPE.LOAN) }}
												</span>
												<span class="float-end p-0">
													[평당:{{ $formatMoney(itemList[i].item.public_land_price_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
												</span>
											</td>
										</tr>
										<tr>
											<th>도로사항</th>
											<td>
												<template v-if="itemList[i].item.roadwide_1">{{ itemList[i].item.roadwide_1 }}m</template>
												<template v-if="itemList[i].item.roadwide_2">,{{ itemList[i].item.roadwide_2 }}m</template>
												<template v-if="itemList[i].item.roadwide_3">,{{ itemList[i].item.roadwide_3 }}m</template>
												<template v-if="itemList[i].item.roadwide_4">,{{ itemList[i].item.roadwide_4 }}m</template>
												<template v-if="itemList[i].item.chk_road_coner == 'Y'">,코너</template>
												<template v-if="itemList[i].item.chk_road_dual == 'Y'">,양면</template>
												<template v-if="itemList[i].item.road_name"> [{{ itemList[i].item.road_name }}]</template>
											</td>
										</tr>
									</table>
								</div>
							</div>
							<div class="area-bldg">

								<!-- 섹션 D: 건축물정보 -->
								<div class="section-tit section-tit--print-header">건축물정보</div>
								<div class="table-wrap">
									<table class="table text-left type-input compact">
										<colgroup>
											<col width="32%" />
											<col width="68%" />
										</colgroup>
										<tr>
											<th class="txt-c--red">연면적</th>
											<td class="txt-c--red">
												<span class="float-start p-0">{{ $formatArea(itemList[i].item.total_size_m2) }}㎡({{ $formatArea(itemList[i].item.total_size_p) }}평)</span>
												<span class="float-end p-0">
													[평당:{{ $formatMoney(itemList[i].item.total_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
												</span>
											</td>
										</tr>
										<tr>
											<th>건축면적</th>
											<td>
												<span class="float-start p-0">{{ $formatArea(itemList[i].item.build_size_m2) }}㎡({{ $formatArea(itemList[i].item.build_size_p) }}평)</span>
												<span class="float-end p-0">
													[평당:{{
														$formatMoney((itemList[i].item.build_size_p ? Math.floor(itemList[i].item.sell_price / itemList[i].item.build_size_p) : 0), $MONEY_FORMAT_TYPE.LOAN)
													}}]
												</span>
											</td>
										</tr>
										<tr>
											<th>규모</th>
											<td>{{ $getFloorString(itemList[i].item.floor_cnt_B, itemList[i].item.floor_cnt_F) }}</td>
										</tr>
										<tr>
											<th>준공년도 / 리모델링</th>
											<td>{{ $dateKorFormat(itemList[i].item.build_date) + ' / ' + $dateKorFormat(itemList[i].item.remodel_date) }}</td>
										</tr>
										<tr>
											<th>주용도</th>
											<td>{{ itemList[i].item.main_purpose }}</td>
										</tr>
										<tr>
											<th>건폐율 / 용적률</th>
											<td>{{ $formatRatio(itemList[i].item.bl_ratio) }}/{{ $formatRatio(itemList[i].item.fa_ratio) }}</td>
										</tr>
										<tr>
											<th>주차방식/대수</th>
											<td>
												<template v-if="itemList[i].item.park_type_name">{{ itemList[i].item.park_type_name }} /</template>
												법정 {{ itemList[i].item.park_cnt_law }}대 / 실제 {{ itemList[i].item.park_cnt_real }}대
											</td>
										</tr>
										<tr>
											<th>냉/난방식</th>
											<td>{{ itemList[i].item.heat_type_name }}</td>
										</tr>
										<tr>
											<th>승강기</th>
											<td>{{ itemList[i].item.ev_cnt }}대</td>
										</tr>
									</table>
								</div>
							</div>

							</div>
							</div>
							<!-- 우측 컬럼: 상단 사각형 사진 + 하단 특징 -->
							<div class="overview-right">
								<div class="right-photo right-photo-square">
									<img v-if="itemList[i].item.img" :src="itemList[i].item.img" alt="" class="right-photo-img" />
								</div>
								<div class="area-feat">
									<div class="section-tit section-tit--print-header features-header">특징</div>
									<ol class="features-list box-line">
										<li v-for="(line, idx) in getFeatureLines(itemList[i].item.memo)" :key="idx">{{ line }}</li>
									</ol>
								</div>
							</div>
							</div>
						<div class="page-footer-disclaimer">
							<p>{{ pageFooterLine1 }}</p>
							<p>{{ pageFooterLine2 }}</p>
						</div>
					</div>
					<!-- 3. 임대정보 -->
					<div
						v-if="opList[3]"
						:id="'capture_item_3_' + i"
						:key="'capture_item_3_' + i"
						name="capture"
						class="print-section"
					>
						<div class="print-tit">STACKING PLAN - {{ itemList[i].item.building_name }}</div>
						<div class="table-wrap">
							<table class="table sm">
								<thead>
									<tr>
										<th>층</th>
										<th>임대면적(㎡)</th>
										<th>임대면적(평)</th>
										<th>용도</th>
										<th>보증금</th>
										<th>월세</th>
										<th>관리비</th>
										<th>평당임대료</th>
										<th>만기</th>
										<th>비고</th>
									</tr>
								</thead>
								<tbody>
									<tr :key="'rent_' + rent.building_rent_uid" v-for="rent in itemList[i].rentList" :class="{ 'rent-excluded': rent.except_flag === 'Y' }">
										<th>{{ rent.rent_floor }}</th>
										<td>{{ $formatArea(rent.rent_size_m2) }}</td>
										<td>{{ $formatArea(rent.rent_size_p) }}</td>
										<td>{{ rent.rent_usage }}</td>
										<td>{{ $formatNumber(rent.rent_deposit) }}</td>
										<td>{{ $formatNumber(rent.rent_money) }}</td>
										<td>{{ rent.mgr_fee ? $formatNumber(rent.mgr_fee) : 0 }}</td>
										<td>{{ $formatNumber(rent.rent_ni) }}</td>
										<td>{{ rent.end_date }}</td>
										<td>{{ rent.memo }}</td>
									</tr>
									<tr>
										<th class="bg-blue">합계</th>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.m2) }}</td>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.py) }}</td>
										<td class="bg-blue"></td>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.deposit) }}</td>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.money) }}</td>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.mgr) }}</td>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.rent_ni) }}</td>
										<td class="bg-blue"></td>
										<td class="bg-blue"></td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="table-text">* 임대차계약서 상 임대면적의 총합과 건축물대장 상 연면적이 다소 차이가 있음</div>
						<div class="page-footer-disclaimer">
							<p>{{ pageFooterLine1 }}</p>
							<p>{{ pageFooterLine2 }}</p>
						</div>
					</div>
					<!-- 4. 건축물정보 -->
					<div
						v-if="opList[4]"
						:id="'capture_item_4_' + i"
						:key="'capture_item_4_' + i"
						name="capture"
						class="print-section"
					>
						<div class="print-tit">BUILDING REGISTER - {{ itemList[i].item.building_name }}</div>
						<div class="table-wrap">
							<table class="table sm">
								<thead>
									<tr>
										<th>층</th>
										<th>면적(㎡)</th>
										<th>평수</th>
										<th>층별용도</th>
									</tr>
								</thead>
								<tbody>
									<tr :key="'floor_' + floor.building_floor_uid" v-for="floor in itemList[i].floorList" :class="{ 'floor-excluded': floor.chk_except === 'Y' }">
										<td>{{ floor.flrNoNm }}</td>
										<td>{{ $formatArea(floor.area_m2) }}</td>
										<td>{{ $formatArea(floor.area_py) }}</td>
										<td>{{ floor.name }}</td>
									</tr>
									<tr>
										<td class="bg-blue">합계</td>
										<td class="bg-blue">{{ itemList[i].totalFloorData.m2 }}</td>
										<td class="bg-blue">{{ itemList[i].totalFloorData.py }}</td>
										<td class="bg-blue"></td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="page-footer-disclaimer">
							<p>{{ pageFooterLine1 }}</p>
							<p>{{ pageFooterLine2 }}</p>
						</div>
					</div>
					<InvestmentAnalysisPage v-if="invShow && invAcqOf(i)" :id="'capture_inv_' + i" :acq="invAcqOf(i)" :tax-rate="itemList[i].invState.taxRate" :broker-rate="itemList[i].invState.brokerRate" :ltv="itemList[i].invState.ltv" :loan-rate="itemList[i].invState.loanRate" :noi="itemList[i].invState.noi" :residential="invResidentialOf(i)" />
					<DevelopmentPlanPage v-if="devShow && invDevOf(i) && invFundingOf(i)" :id="'capture_dev_' + i" :dev="invDevOf(i)" :funding="invFundingOf(i)" />
					<!-- 5. 건물 내/외부 (사진 여러개)-->
					<template v-if="opList[5]">
						<div
							v-for="(pic, idx) in itemList[i].item.imgObj"
							:id="'picture_' + itemList[i].item.building_uid + '_' + idx"
							:key="'picture_' + itemList[i].item.building_uid + '_' + idx"
							class="print-section flex"
							name="capture"
						>
							<div class="print-tit">PHOTO - {{ itemList[i].item.building_name }}</div>
							<template v-for="(l, ll) in pic" :key="idx + '_' + ll + '_' + 'pic_' + itemList[i].item.building_uid">
								<div v-if="(ll = 0)" class="left">
									<div class="section-tit">{{ l.name }}</div>
									<div class="img-wrap">
										<img :src="l.img" alt="" style="width: 540px; height: 650px" />
									</div>
								</div>
								<div v-else class="right">
									<div class="section-tit">{{ l.name }}</div>
									<div class="img-wrap">
										<img :src="l.img" alt="" style="width: 540px; height: 650px" />
									</div>
								</div>
							</template>
							<div class="page-footer-disclaimer">
								<p>{{ pageFooterLine1 }}</p>
								<p>{{ pageFooterLine2 }}</p>
							</div>
						</div>
					</template>
					<!-- 6. 지도 -->
					<div v-show="opList[6]" :id="'capture_item_6_' + i" name="capture" class="print-section flex">
						<div class="left">
							<div class="print-tit">MAP - {{ itemList[i].item.building_name }}</div>
							<div :id="'map_1_' + i"></div>
						</div>
						<div class="right">
							<div class="print-tit">MAP - {{ itemList[i].item.building_name }}</div>
							<div :id="'map_2_' + i"></div>
						</div>
						<div class="page-footer-disclaimer">
							<p>{{ pageFooterLine1 }}</p>
							<p>{{ pageFooterLine2 }}</p>
						</div>
					</div>
					<!-- #7 부록 슬라이드(매물별, 맨 뒤) -->
					<SlidePage v-for="s in (itemList[i].slides || [])" :key="'slide_' + i + '_' + s.id" :id="'slide_' + i + '_' + s.id" name="capture" :slide="s" />
					<!-- 7. end -->
					<div v-if="i == bidList[bidList.length - 1]" name="capture" id="capture_99" class="print-section cover end">
						<ul class="info" :class="cobrandClass">
							<li class="info-item name">
								<span class="text">
									<strong>{{ userInfo.mem_name }}</strong> {{ userInfo.mem_rank_name }}
								</span>
							</li>
							<li class="info-item">
								<label class="label">M.</label>
								<span class="text">{{ userInfo.mem_mobile }}</span>
							</li>
							<li class="info-item">
								<label class="label">T.</label>
								<span class="text">02-6956-2791</span>
							</li>
							<li class="info-item">
								<label class="label">E.</label>
								<span class="text">{{ userInfo.mem_email }}</span>
							</li>
							<li class="info-item">
								<label class="label">F.</label>
								<span class="text">{{ userInfo.mem_fax || '070-4693-5728' }}</span>
							</li>
							<li class="info-item">
								<span class="text">서울특별시 강남구 학동로25길 11, 5층 (논현동, 씨플레이스)</span>
							</li>
						</ul>
						<!-- 신한/대신 제휴 게스트 PDF: 위온어스 중개법인 Contact Point 배너(첨부 디자인) 항상 표기 -->
						<div class="broker-corp" v-if="cobrandClass">
							<div class="bc-title">Contact Point</div>
							<div class="bc-corp"><strong>위온어스부동산중개법인</strong><span class="bc-addr"> (서울특별시 강남구 학동로25길 11, 5층(논현동, 씨플레이스))</span></div>
							<div class="bc-col bc-col1">
								<div class="bc-name">서치원 대표</div>
								<div class="bc-tel">+82 010-5566-4948</div>
							</div>
						</div>
						<div class="bottom-text">
							본 Teaser는 본 건 투자를 위한 기본적인 정보를 제공할 목적으로 작성되었습니다. Teaser의 세부적인 내용은
							추후 진행사항에 따라 수정되거나 변경될 수 있고, WEONUS 는 내용에 대해 어떠한 책임도 부담하지 않습니다.<br />
							또한 Teaser에서 제공한 정보는 어떠한 제약의 근거로 사용될 수 없습니다. Teaser의 어떠한 부분도 매도자 및
							WEONUS의 사전 동의 없이 외부에 복사, 인용, 재배포 및 유통될 수 없습니다.
						</div>
					</div>
				</template>

				<!--

				7. end
				<div name="capture" id="capture_6" class="print-section cover">
					<ul class="info">
						<li class="info-item">
							<label class="label">담당자</label>
							<span class="text">박정훈 차장</span>
						</li>
						<li class="info-item">
							<label class="label">Mobile</label>
							<span class="text">010-3441-5886</span>
						</li>
						<li class="info-item">
							<label class="label">TEL</label>
							<span class="text"></span>
						</li>
						<li class="info-item">
							<label class="label">FAX</label>
							<span class="text">02-111-2222</span>
						</li>
						<li class="info-item">
							<label class="label">E-mail</label>
							<span class="text"></span>
						</li>
						<li class="info-item">
							<span class="text">서울특별시 강남구 학동로25길 11, 5층 (논현동, 씨플레이스)</span>
						</li>
					</ul>
					<div class="bottom-text">
						본 Teaser는 본건 투자를 위한 기본적인 정보를 제공할 목적으로 작성되었습니다.<br />
						본 Teaser의 내용은 추후 진행사항에 따라 수정되거나 변경될 수 있고,<br />
						내용의 대하여 어떠한 책임도 부담하지 아니합니다. <br />
						또한 본 Teaser에서 제공된 정보는 어떠한 제약의 근거로 사용될 수 없습니다.<br />
						본 Teaser의 어떤 부분도 매도자 및 WEONUS의 사전 서면동의 없이 <br />
						외부에 복사, 인용, 배포, 유통될 수 없습니다.
					</div>
				</div>
				8. 임대 개요
				<div name="capture" id="capture_7" class="print-section flex1-2">
					<div class="left">
						<div class="img-wrap">
							<img src="" alt="" />
						</div>
					</div>
					<div class="right">
						<div class="flex">
							<div>
								<div class="section-tit">임대정보</div>
								<div class="table-wrap">
									<table class="table type-input">
										<colgroup>
											<col width="20%" />
											<col width="30%" />
											<col width="20%" />
											<col width="30%" />
										</colgroup>
										<tr>
											<th>주소</th>
											<td colspan="3">서울</td>
										</tr>
										<tr>
											<th class="txt-c--red">보증금</th>
											<td colspan="3" class="txt-c--red">1만원</td>
										</tr>
										<tr>
											<th class="txt-c--red">월세</th>
											<td colspan="3" class="txt-c--red">1만원</td>
										</tr>
										<tr>
											<th>관리비</th>
											<td colspan="3">1만원</td>
										</tr>
										<tr>
											<th class="txt-c--red">월고정비</th>
											<td colspan="3" class="txt-c--red">1만원</td>
										</tr>
										<tr>
											<th class="txt-c--red">전용면적</th>
											<td class="txt-c--red">0평</td>
											<th>전용률</th>
											<td>80%</td>
										</tr>
										<tr>
											<th>임대면적</th>
											<td colspan="3">0평</td>
										</tr>
										<tr>
											<th class="txt-c--red">평당임대료</th>
											<td colspan="3" class="txt-c--red">1만원</td>
										</tr>
										<tr>
											<th>층정보</th>
											<td>1층</td>
											<th>입주현황</th>
											<td>공실</td>
										</tr>
										<tr>
											<th>무료 주차대수</th>
											<td>100평당 1대</td>
											<th>유료 주차대수</th>
											<td>가능</td>
										</tr>
										<tr>
											<th>화장실 유형</th>
											<td colspan="3">각 층 남녀 분리</td>
										</tr>
										<tr>
											<th>인테리어</th>
											<td colspan="3">철거완료</td>
										</tr>
										<tr>
											<th>렌트프리</th>
											<td colspan="3">2개월</td>
										</tr>
									</table>
								</div>
							</div>
							<div>
								<div class="section-tit">토지정보</div>
								<div class="table-wrap">
									<table class="table type-input">
										<colgroup>
											<col width="50%" />
											<col width="50%" />
										</colgroup>
										<tr>
											<th class="txt-c--red">주변역</th>
											<td class="txt-c--red">00역</td>
										</tr>
										<tr>
											<th class="txt-c--red">거리</th>
											<td class="txt-c--red">22m</td>
										</tr>
										<tr>
											<th>대지면적</th>
											<td>00㎡</td>
										</tr>
										<tr>
											<th>도로사항</th>
											<td>00㎡ 코너</td>
										</tr>
									</table>
								</div>
								<div class="section-tit mt-4">건축물정보</div>
								<div class="table-wrap">
									<table class="table type-input">
										<colgroup>
											<col width="50%" />
											<col width="50%" />
										</colgroup>
										<tr>
											<th>준공연도/리모델링</th>
											<td>2022-01-01 / 2022-01-01</td>
										</tr>
										<tr>
											<th class="txt-c--red">승강기</th>
											<td class="txt-c--red">1대</td>
										</tr>
										<tr>
											<th>냉/난방식</th>
											<td>개별 냉/난방</td>
										</tr>
										<tr>
											<th>규모</th>
											<td>지하1층 / 지상10층</td>
										</tr>
										<tr>
											<th>주차방식/대수</th>
											<td>자주식 / 10대</td>
										</tr>
										<tr>
											<th>연면적</th>
											<td>11.11[10평]</td>
										</tr>
										<tr>
											<th>건축면적</th>
											<td>11.11[10평]</td>
										</tr>
									</table>
								</div>
							</div>
						</div>
						<div class="section-tit mt-4">특징</div>
						<ul class="dot-list">
							<li class="dot-list--item">특징1</li>
							<li class="dot-list--item">특징2</li>
							<li class="dot-list--item">특징3</li>
						</ul>
					</div>
				</div>
				9. 비교
				<div name="capture" id="capture_8" class="print-section flex2-1">
					<div class="left">
						<div class="print-tit">COMPARABLE(비교)</div>
						<div class="table-wrap">
							<table class="table type-input">
								<colgroup>
									<col width="25%" />
									<col width="25%" />
									<col width="25%" />
									<col width="25%" />
								</colgroup>
								<tr>
									<th>빌딩명</th>
									<th>ㅇㅇ빌딩</th>
									<th>ㅁㅁ빌딩</th>
									<th>ㅅㅅ빌딩</th>
								</tr>
								<tr>
									<th>사진</th>
									<td>사진</td>
									<td>사진</td>
									<td>사진</td>
								</tr>
								<tr>
									<th>주소</th>
									<td>00시</td>
									<td>00시</td>
									<td>00시</td>
								</tr>
								<tr>
									<th class="txt-c--red">보증금</th>
									<td class="txt-c--red">1만원</td>
									<td class="txt-c--red">1만원</td>
									<td class="txt-c--red">1만원</td>
								</tr>
								<tr>
									<th class="txt-c--red">월세</th>
									<td class="txt-c--red">1만원</td>
									<td class="txt-c--red">1만원</td>
									<td class="txt-c--red">1만원</td>
								</tr>
								<tr>
									<th>관리비</th>
									<td>1만원</td>
									<td>1만원</td>
									<td>1만원</td>
								</tr>
								<tr>
									<th class="txt-c--red">월 고정비</th>
									<td class="txt-c--red">1만원</td>
									<td class="txt-c--red"></td>
									<td class="txt-c--red"></td>
								</tr>
								<tr>
									<th class="txt-c--red">전용면적</th>
									<td class="txt-c--red">10㎡(10평)</td>
									<td class="txt-c--red"></td>
									<td class="txt-c--red"></td>
								</tr>
								<tr>
									<th>전용률</th>
									<td>10%</td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<th>임대면적</th>
									<td>10㎡(10평)</td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<th>층정보</th>
									<td>1층 전체</td>
									<td>1층 전체</td>
									<td>1층 전체</td>
								</tr>
								<tr>
									<th class="txt-c--red">평당임대료</th>
									<td class="txt-c--red">15만원</td>
									<td class="txt-c--red"></td>
									<td class="txt-c--red"></td>
								</tr>
								<tr>
									<th>입주현황</th>
									<td>즉시입주</td>
									<td>즉시입주</td>
									<td>협의</td>
								</tr>
								<tr>
									<th>주차(유료/무료)</th>
									<td>유료1대/무료2대</td>
									<td>유료1대/무료2대</td>
									<td>유료1대/무료2대</td>
								</tr>
								<tr>
									<th>화장실 유형</th>
									<td>개별 냉난방</td>
									<td>중앙 냉난방</td>
									<td>개별 냉난방</td>
								</tr>
								<tr>
									<th>인테리어</th>
									<td>철거완료</td>
									<td>철거완료</td>
									<td>철거완료</td>
								</tr>
								<tr>
									<th>렌트프리</th>
									<td>렌트프리3개월</td>
									<td>렌트프리3개월</td>
									<td>-</td>
								</tr>
								<tr>
									<th class="txt-c--red">주변역/거리</th>
									<td class="txt-c--red">역삼역(2호선) 300m</td>
									<td class="txt-c--red">역삼역(2호선) 300m</td>
									<td class="txt-c--red">역삼역(2호선) 300m</td>
								</tr>
								<tr>
									<th class="txt-c--red">승강기</th>
									<td class="txt-c--red">1대</td>
									<td class="txt-c--red"></td>
									<td class="txt-c--red"></td>
								</tr>
								<tr>
									<th>준공년도/리모델링</th>
									<td>2022.01.01</td>
									<td>2022.01.01</td>
									<td>2022.01.01</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="right">
						<div class="section-tit">서울 강남구</div>
						<div class="map-wrap"></div>
						<div class="table-wrap">
							<div class="txt-right txt-size--sm mb-1">단위:원</div>
							<table class="table type-input">
								<tr>
									<th>NO.</th>
									<th>빌딩이름</th>
									<th>전용면적</th>
									<th>보증금</th>
									<th>월세</th>
									<th>관리비</th>
									<th>월고정비</th>
								</tr>
								<tr>
									<td>01</td>
									<td>유진빌딩(지하2~지상6층)</td>
									<td>20평</td>
									<td>60000</td>
									<td>60000</td>
									<td>포함</td>
									<td>60000</td>
								</tr>
							</table>
						</div>
					</div>
				</div>

				-->
			</div>
		</div>
	</div>
</template>

<script>
import { normalizeAddr, formatBodyAddr } from '@/utils/format';
import {
	buildDefaults, computeAcquisition, computeDevelopment, computeEstimateBadge,
	computeFundingComparison, isResidential, DEFAULT_NOTE,
	serializeInvestment, applyInvestmentQuery, QUERY_KEYS,
} from '@/utils/investment.mjs';
import { serializeSlides, slidesFromQueryValue, makeBlankSlide, makePhotoSlide } from '@/utils/printSlides.mjs';
import { startPrintPage, markStage, markReady, markFailed } from '@/utils/printStatus.mjs';
import InvestmentAnalysisPage from '@/components/print/InvestmentAnalysisPage.vue';
import DevelopmentPlanPage from '@/components/print/DevelopmentPlanPage.vue';
import InvestmentSidebarEditor from '@/components/print/InvestmentSidebarEditor.vue';
import SlidePage from '@/components/print/SlidePage.vue';
import SlideEditor from '@/components/print/SlideEditor.vue';

// 추정가(AVM, bloc valuation) ready 게이트 상한(ms). PR#78(2026-06-08)이 추정가 출처를
// 다필지+건물 valuation(부하 시 간헐 15s 타임아웃)으로 바꾼 뒤, 이 비동기 로드가 init 의
// critical path(loadSt·지도·__VUE_READY__)에 await 로 묶여 연쇄 PDF 가 지도 공백/빈 페이지를
// 냈다. 이 시간 내 도착하면 캡처 포함, 늦으면 진행(도착 시 반응성 표시). 건강 시 valuation≈1.8s.
const EST_READY_GATE_MS = 4000;

export default {
	name: 'PrintPage2',
	components: {
		InvestmentAnalysisPage,
		DevelopmentPlanPage,
		InvestmentSidebarEditor,
		SlidePage,
		SlideEditor,
	},
	data() {
		return {
			loadSt: false,
			bid: null,
			bidList: null,

			indexList: [],
			capIdList: [],
			isPdfLoading: false,
			// F-5.1: progress indicator state for $exportPrint
			pdfLoadingMsg: '',
			pdfLoadingCurrent: 0,
			pdfLoadingTotal: 0,

			opAll: true,
			opList: [true, true, true, true, true, true, true, true],

			// 표지 하단 disclaimer — V01/V02/V05 공통
			disclaimerText: '본 Teaser는 본 건 투자 검토를 위한 기본적인 정보를 제공할 목적으로 작성되었습니다. 본 자료의 세부 내용은 향후 진행 상황에 따라 수정 또는 변경될 수 있으며, WEONUS는 이에 대해 어떠한 법적 책임도 부담하지 않습니다. 또한 본 자료에 포함된 정보는 투자 판단 또는 계약 체결의 근거로 사용될 수 없습니다.',

			// 2페이지 이후 모든 페이지 하단에 작게 표기되는 법적 고지 (comparable, capture_item_2~capture_item_6).
			pageFooterLine1: '* 본 자료에는 공개가 제한되거나 매도인의 비밀정보가 포함될 수 있습니다. 수신인이 불필요하게 수령한 경우 즉시 파기하여야 하며, WEONUS 및 매도인의 사전 서면 동의 없이 본 자료의 전부 또는 일부를 복제, 배포, 전송, 인용, 변경 또는 제3자에게 제공할 수 없습니다. 위반 시 관련 법령에 따른 민·형사상 책임이 발생할 수 있습니다.',
			pageFooterLine2: '* 본 자료는 매도인의 진술 및 제공 자료를 기초로 작성되어 실제와 차이가 있을 수 있습니다.',

			item: null,
			itemList: [],
			itemGroup: [],

			isBid: null,
			slideUploading: false,

			// ③투자분석 표시 토글(매매 변형 기본 ON). 건물별 invState 는 itemList[bid].invState.
			invShow: true,
			// 리모델링/신축은 기본 OFF(선택 제외).
			devShow: false,

			userInfo: {},

			// 표지(cover) 4 variant 선택. 기본값 '02' (Bold Burgundy, 현 디자인 가장 근접).
			// URL ?cover=00|01|02|05 로 동기화됨. '00'은 구버전(common.scss 의 .print-section.cover 글로벌 스타일).
			coverVariants: [
				{ id: '00', label: '00 Classic' },
				{ id: '01', label: '01 Editorial' },
				{ id: '02', label: '02 Bold Burgundy' },
				{ id: '05', label: '05 Boutique Advisory' },
			],
			coverVariant: ['00', '01', '02', '05'].includes(this.$route.query.cover)
				? this.$route.query.cover
				: '02',
		};
	},
	created() {
		// F-6.1: 방어선 — bid 쿼리 누락/공백일 때 TypeError 로 빈 페이지가 뜨고
		// 그 상태로 출력 버튼이 노출되면 서버에 빈 idList 가 전송돼 1KB 백지 PDF 가 내려간다.
		// 명시적으로 alert + 복귀 후 init 을 스킵한다.
		const rawBid = this.$route.query.bid;
		if (!rawBid || typeof rawBid !== 'string') {
			alert('잘못된 접근입니다. 매물 목록에서 다시 시도해주세요.');
			this.$router.back();
			return;
		}
		// trailing comma / 연속 콤마로 생기는 빈 문자열은 제외 ("a,,b," → ["a","b"]).
		this.bidList = rawBid.split(',').map(s => s.trim()).filter(Boolean);
		if (this.bidList.length === 0) {
			alert('선택된 매물이 없습니다.');
			this.$router.back();
			return;
		}

		// ③④ 토글 상태 URL 복원(서버 PDF 가 window.location.href 재로드 시 반영).
		if (this.$route.query.inv_show != null) this.invShow = String(this.$route.query.inv_show) !== '0';
		if (this.$route.query.dev_show != null) this.devShow = String(this.$route.query.dev_show) !== '0';

		for (let i = 0; i < this.bidList.length; i++) {
			this.bid = this.bidList[i];

			if (i == 0) {
				this.isBid = this.bid;
			}

			let dataObject = {
				id: this.bid,
				item: [],
				coverAddr: '',
				bodyAddr: '',
				rentList: [],
				floorList: [],
				totalData: {
					m2: 0,
					py: 0,
					deposit: 0,
					money: 0,
					mgr: 0,
				},
				totalFloorData: {
					m2: 0,
					py: 0,
				},

				rentRate: {
					labels: ['임대율'],
					datasets: [
						{
							label: '임대율',
							data: [0],
							backgroundColor: '#f87979',
						},
					],
				},
				rentRateSt: false,
				rentRateList: {
					labels: ['임대'],
					datasets: [],
				},
				rentRateListSt: false,

				map_1: null,
				marker_1: null,
				map_2: null,
				marker_2: null,
				mapType: null,

				// 추정가(AVM) 매물별 상태. estimate.total/py 는 표시값이자 편집 대상(임시).
				// showEstimate 기본값: 비활성화. 추정가 로드 후 매매가보다 높을 때만 applyEstimateShowDefault 가 활성화.
				estimate: { available: false, total: 0, py: 0, areaPy: 0 },
				showEstimate: false,
				slides: [],   // #7 부록 슬라이드(매물별)
			};

			this.itemList[this.bid] = dataObject;
		}

		// 지도 전용 출력 페이지(Panorama 미사용): base SDK(naver.maps.Map) 준비만 기다린다.
		// 'core' 로 호출해 panorama 서브모듈 지연/실패가 지도·PDF 렌더를 막지 않게 한다.
		this.mapScriptReady = this.$loadNaverMaps('core');

		// F-6.4: getItem 이 전체 bid 실패 시 throw 하므로 unhandled rejection 방지.
		// alert 는 getItem 내부에서 이미 띄워 사용자에게 알렸고, 여기서는 깔끔히 중단.
		startPrintPage();
		// init 이 중단되면 서버가 30초를 기다리게 두지 않고 원인을 실어 즉시 알린다.
		// (alert 는 getItem 내부에서 이미 사용자에게 띄웠다.)
		this.init().catch(e => {
			console.warn('init aborted:', e);
			markFailed('init aborted: ' + ((e && e.message) || e));
		});
	},
	computed: {
		estimateNoteText() { return DEFAULT_NOTE; },
		// 표지 대표이미지 URL — 첫 매물. (native <img> 로 로드해서 puppeteer 캡처 대기 적용.)
		coverImgFirst() {
			const firstBid = this.bidList && this.bidList[0];
			return firstBid && this.itemList[firstBid] && this.itemList[firstBid].item
				? this.itemList[firstBid].item.img
				: null;
		},
		// 표지 주소 표기 — 첫 매물의 coverAddr (로드 전에는 빈 문자열).
		coverAddrFirst() {
			const firstBid = this.bidList && this.bidList[0];
			return firstBid && this.itemList[firstBid]
				? this.itemList[firstBid].coverAddr || ''
				: '';
		},
		// 페이지 워터마크 'weonus' 아래줄에 출력자(로그인 사용자) 이름 표기.
		// CSS 변수 --print-watermark-name 으로 .print-section::before 가 읽는다.
		watermarkStyle() {
			const name = (this.userInfo && this.userInfo.mem_name) || '';
			return name ? { '--print-watermark-name': `'${name.replace(/'/g, '')}'` } : {};
		},
		// 제휴 게스트(은행직원) 세션에서만 — 마지막 페이지 위온어스 × 기관 공동로고.
		cobrandClass() {
			if (!this.$store.getters.getGuest) return null;
			const inst = this.$store.getters.getInstitution;
			return inst === 'shinhan' || inst === 'daishin' ? inst : null;
		},
	},
	watch: {
		coverVariant(newVal) {
			// URL query 동기화 (새로고침/공유 대비).
			const currentQuery = { ...this.$route.query };
			if (currentQuery.cover === newVal) return;
			this.$router.replace({ query: { ...currentQuery, cover: newVal } }).catch(() => {});
		},
	},
	updated() {},
	methods: {
		// ─── ③투자분석/④자금계획 (건물별) ───────────────────────────────
		// 단일물건 mixin(investmentProposal) 은 this.item 단일 가정이라 연쇄출력엔 부적합.
		// 매물별 invState 를 itemList[bid] 에 시드하고, 페이지는 bid 별 헬퍼로 계산값을 주입.
		seedInvestmentStates() {
			for (const bid of this.bidList) {
				const it = this.itemList[bid];
				if (it && it.item) {
					it.invState = buildDefaults(it.item);
					// 담당자 저장 기본값(DB) 을 기본값 위에, 그 위에 URL(타직원 임시수정) 을 덮는다. (buildDefaults→DB→URL)
					// 단, 페이지 토글(inv_show/dev_show) 은 덱 전역 단일값이라 매물별 DB 값 미적용(의도).
					if (it.item.printDefaults && typeof it.item.printDefaults === 'object') {
						applyInvestmentQuery(it.invState, it.item.printDefaults);
					}
					this.applyInvestmentUrlOverride(bid); // 편집값(URL) 을 기본값 위에 덮어쓴다 — 서버 PDF 재로드 대비.
					// #7 슬라이드: DB(printDefaults.slides) → URL(slides_<bid>) 오버라이드.
					{ const dbSlides = it.item.printDefaults && it.item.printDefaults.slides; const urlSlides = (this.$route.query || {})['slides_' + bid]; it.slides = slidesFromQueryValue(urlSlides != null ? urlSlides : dbSlides); }
				}
			}
		},
		invStateOf(bid) {
			const it = this.itemList[bid];
			return it && it.invState ? it.invState : null;
		},
		invAcqOf(bid) {
			const s = this.invStateOf(bid);
			return s ? computeAcquisition(s) : null;
		},
		invDevOf(bid) {
			const s = this.invStateOf(bid);
			return s ? computeDevelopment(s) : null;
		},
		invFundingOf(bid) {
			const a = this.invAcqOf(bid);
			const d = this.invDevOf(bid);
			return (a && d) ? computeFundingComparison(a, d) : null;
		},
		invResidentialOf(bid) {
			const it = this.itemList[bid];
			return it && it.item ? isResidential(it.item.main_purpose) : false;
		},
		// 추정가 배지(저평가/운영가치) — 매매가 vs AI추정가. 표시조건 = estimate.available + showEstimate.
		estimateBadgeOf(bid) {
			const it = this.itemList[bid];
			const s = this.invStateOf(bid);
			if (!it || !s || !it.showEstimate || !it.estimate || !it.estimate.available) return null;
			return computeEstimateBadge(s.sellMan, it.estimate.total);
		},
		// 사이드바 편집(InvestmentSidebarEditor) → 즉시 URL 동기화(서버 PDF 재로드 대비).
		onInvestmentEdit() { this.syncInvestmentToUrl(); },
		onInvestmentToggle() { this.syncInvestmentToUrl(); },
		// #7 부록 슬라이드(매물별) ───────────────────────────────
		onSlideChange() { this.syncInvestmentToUrl(); },
		onSelectedAddBlank() { this.addBlankSlideOf(this.isBid); },
		onSelectedAddPhoto(file) { this.addPhotoSlideOf(this.isBid, file); },
		addBlankSlideOf(bid) {
			const it = this.itemList[bid];
			if (!it || !it.slides || it.slides.length >= 20) return;
			it.slides.push(makeBlankSlide(it.slides));
			this.syncInvestmentToUrl();
		},
		async addPhotoSlideOf(bid, file) {
			const it = this.itemList[bid];
			if (!it || !it.slides || !file || this.slideUploading || it.slides.length >= 20) return;
			this.slideUploading = true;
			try {
				const fd = new FormData();
				fd.append('image', file);
				fd.append('bid', it.item.building_uid);
				fd.append('type', 'sell');
				const token = (this.$store.getters.getToken || {}).accessToken || '';
				const res = await fetch(process.env.VUE_APP_HOST_BACK + '/admin/api/detail/item/print-slide/upload', {
					method: 'POST', headers: { Authorization: token }, body: fd,
				});
				const j = await res.json().catch(() => null);
				if (j && j.st && j.id) {
					it.slides.push(makePhotoSlide(it.slides, j.id, ''));
					this.syncInvestmentToUrl();
				} else {
					window.alert('사진 업로드 실패' + (j && j.reason ? ' (' + j.reason + ')' : ''));
				}
			} catch (e) {
				window.alert('사진 업로드 실패');
			} finally {
				this.slideUploading = false;
			}
		},
		// 매물별 invState 를 inv_<bid>_<키> 네임스페이스로 URL 직렬화. 검증된 serializeInvestment 재사용.
		// note 는 PrintPage2 사이드바에서 미편집(상수 DEFAULT_NOTE) → 매물수만큼 중복 영속되는 URL 비대화 방지차 제외.
		syncInvestmentToUrl() {
			const u = new URL(window.location.href);
			[...u.searchParams.keys()].forEach(k => { if (k.indexOf('inv_') === 0 || k.indexOf('slides_') === 0) u.searchParams.delete(k); });
			for (const bid of this.bidList) {
				const it = this.itemList[bid];
				if (!it || !it.invState) continue;
				const q = serializeInvestment(it.invState);
				delete q[QUERY_KEYS.note];
				Object.entries(q).forEach(([key, v]) => u.searchParams.set('inv_' + bid + '_' + key, v));
				const sv = serializeSlides(it.slides);
				u.searchParams.set('slides_' + bid, sv == null ? '[]' : sv);
			}
			u.searchParams.set('inv_show', this.invShow ? '1' : '0');
			u.searchParams.set('dev_show', this.devShow ? '1' : '0');
			window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
		},
		// 서버 재로드 시 inv_<bid>_* 쿼리를 해당 매물 invState 기본값 위에 덮어쓴다.
		applyInvestmentUrlOverride(bid) {
			const it = this.itemList[bid];
			if (!it || !it.invState) return;
			const prefix = 'inv_' + bid + '_';
			const query = this.$route.query || {};
			const q = {};
			Object.keys(query).forEach(k => { if (k.indexOf(prefix) === 0) q[k.slice(prefix.length)] = query[k]; });
			applyInvestmentQuery(it.invState, q);
		},
		// 출력 파일명용 빌딩명: 첫 매물명(+ '외 N건'). seon.js 가 '위온어스_' 접두 부여.
		reportFileName() {
			const ids = Array.isArray(this.bidList) ? this.bidList : [];
			const first = (ids.length && this.itemList[ids[0]]) ? this.itemList[ids[0]].item.building_name : '';
			if (!first) return '';
			return ids.length > 1 ? `${first} 외 ${ids.length - 1}건` : first;
		},
		// 보이는(offsetParent!==null) + id 있는 capture 섹션만 수집한다.
		// 지도는 v-show 라 체크 해제해도 display:none 으로 DOM 에 잔존하는데, 이를 capIdList 에 담으면
		// 서버 PDF 가 그 섹션을 빈/거대 페이지로 렌더해 전체가 축소되고 빈 페이지가 늘어난다. 그래서 필터링.
		collectCaptureIds() {
			const ids = [];
			const nodes = document.getElementsByName('capture');
			for (let i = 0; i < nodes.length; i++) {
				const el = nodes[i];
				if (el.id && el.offsetParent !== null) ids.push(el.id);
			}
			return ids;
		},
		// invShow/devShow 토글로 ③④ v-if 페이지가 추가/제거된 뒤 capIdList stale 방지(출력 직전 재수집).
		rebuildCapIdList() {
			markStage('dom-rendered');
			this.capIdList = this.collectCaptureIds();
		},
		getFeatureLines(memo) {
			// 머릿글 strip — 자동 카운터(01/02..)와 중복되지 않도록 한 줄 앞에서
			//   - 기호: ▶ ▷ ► ▸ ➤ → > • · - *
			//   - 대괄호 숫자: [1] [2] [10] ...
			//   - 점/괄호 숫자: 1. 1) 1)
			// 위 패턴이 1개 이상 연속해 있어도 모두 제거.
			return (memo || '')
				.split('\n')
				.map(l => l.trim())
				.filter(l => l.length > 0)
				.map(l => l.replace(/^(?:\[\d+\]|\d+[.)]|[▶▷►▸➤→>•·\-*])+\s*/, ''));
		},
		async init() {
			// ─────────────────────────────────────────────────────────────
			// F-6.2: 연쇄출력(PrintPage2) capIdList / 지도 race 수정.
			//
			// 과거 동작:
			//   getItem() 내부 this.$nextTick 에서 getElementsByName('capture')
			//   으로 capIdList 를 수집 + __VUE_READY__ 를 세팅했다. 그런데 이 시점엔
			//   loadSt 가 아직 false → 템플릿 <div v-if="loadSt"> 가 DOM 에 존재하지
			//   않아 capIdList 가 [] 로 남았고, 클릭 시 $exportPdf([]) 가 호출돼
			//   서버가 0 개 섹션을 복제한 백지 1페이지 PDF(1,055 bytes) 를 반환했다.
			//   지도도 같은 이유로 mainMap_*/map_1_*/map_2_* 컨테이너를 찾지 못해
			//   "Container mainMap_0 not found" 가 찍히며 렌더 실패.
			//
			// 수정 동작:
			//   1. getItem — 데이터만 채움 (DOM 의존 작업 없음).
			//   2. rent/floor/user/land 를 Promise.all 로 병렬 수행 (속도 유지).
			//      각각 try/catch 로 하나가 실패해도 전체 출력이 중단되지 않도록 함.
			//   3. loadSt = true → 템플릿이 print-wrap 을 실제로 렌더.
			//   4. await $nextTick → capture 노드가 DOM 에 생성된 뒤 id 수집.
			//   5. 지도 스크립트가 준비되면 mainLoadMap/loadMap 호출 — 컨테이너 존재 보장.
			//   6. __VUE_READY__ = true → 서버 Puppeteer 가 이때부터
			//      page.waitForSelector(`#${id}`) 를 시도한다. capIdList 수집과
			//      지도 렌더가 끝난 뒤여야 Puppeteer 가 빈 섹션을 캡처하지 않는다.
			// ─────────────────────────────────────────────────────────────
			markStage('item-loading');
			await this.getItem();
			markStage('item-loaded');
			// 저장(DB)/편집(URL) 추정가는 즉시 적용 — 서버 PDF 재렌더는 이 값으로 충분하고,
			// 느린 AVM(valuation) 성패와 무관하게 항상 반영되도록 critical path 앞에 둔다.
			for (const bid of this.bidList) {
				this.applyEstimateDefaults(bid);
				this.applyEstimateUrlOverride(bid);
				this.applyEstimateShowDefault(bid); // 느린 AVM 전에 URL/DB 추정가 기준으로 기본값 확정(getEstimate 에서 AVM 반영해 재적용)
			}
			// AVM 추정가(느린 valuation)는 백그라운드로 — 템플릿(loadSt)/지도/ready 를 막지 않는다.
			// ready 직전에 상한(EST_READY_GATE_MS) 내에서만 best-effort 로 더 기다린다(아래).
			const estimateReady = this.getEstimate().catch(() => {});
			this.seedInvestmentStates();

			// 병렬 보조 데이터 로드 — 각 함수 내부가 이미 .catch 로 실패를 흡수하므로
			// Promise.all 로도 reject 가 올라오지 않는다. 하나의 느린/실패 요청이
			// 전체 init 을 중단시키지 못하도록 .catch 유지 + Promise.all 로 spec 준수.
			await Promise.all([
				this.getRent(),
				this.getFloor(),
				this.getUser(),
				this.getLand(),
			]);

			markStage('aux-loaded');
			this.loadSt = true;

			// print-wrap 이 실제로 DOM 에 생성되도록 다음 틱까지 대기.
			await this.$nextTick();

			// capture 섹션 id 수집 — 이 시점엔 항상 >0 개여야 정상.
			markStage('dom-rendered');
			this.capIdList = this.collectCaptureIds();

			// 지도 렌더 — 네이버 맵 스크립트 로드 실패해도 나머지 페이지는 출력 가능.
			try {
				await this.mapScriptReady;
				await this.$nextTick();
				for (let i = 0; i < this.itemGroup.length; i++) {
					this.mainLoadMap(this.itemGroup[i]);
				}
				for (let i = 0; i < this.bidList.length; i++) {
					const id = this.bidList[i];
					// 주의: DOM div 의 id 는 `map_1_${bid}` / `map_2_${bid}` 이므로
					// loadMap 의 2번째 인자에도 반드시 `bid` 를 넘겨야 한다.
					// building_uid 는 DB 필드라 타입/값이 bid 와 다를 수 있어 id 불일치의
					// 잠재적 원인이 된다. bid 자체를 전달해 DOM id 와 1:1 정합 보장.
					this.loadMap(this.itemList[id].item, id);
				}
				// 네이버 지도는 타일을 비동기(<img>)로 로드한다. new Map() 직후엔
				// $nextTick 으로도 타일이 안 깔려 있어, Puppeteer 가 이 순간 캡처하면
				// 반쯤 그려진 맵이 찍힌다. 'idle' 이벤트(초기 타일 로드 완료)를
				// 맵마다 한 번씩 기다려야 한다. 타일 서버 장애 대비 3초 safety timeout.
				const allMaps = [];
				for (let i = 0; i < this.itemGroup.length; i++) {
					if (this.itemGroup[i].map) allMaps.push(this.itemGroup[i].map);
				}
				for (let i = 0; i < this.bidList.length; i++) {
					const entry = this.itemList[this.bidList[i]];
					if (entry?.map_1) allMaps.push(entry.map_1);
					if (entry?.map_2) allMaps.push(entry.map_2);
				}
				await Promise.all(
					allMaps.map(
						m =>
							new Promise(resolve => {
								let done = false;
								const finish = () => {
									if (!done) {
										done = true;
										resolve();
									}
								};
								try {
									window.naver.maps.Event.once(m, 'idle', finish);
								} catch (e) {
									finish();
									return;
								}
								// 3초 내 idle 이 안 떠도 출력은 진행 — 반쯤 그려진 편이
								// 영구 대기보다 낫다.
								setTimeout(finish, 3000);
							}),
					),
				);
				// 지도 타일이 DOM 에 attach 되는 한 틱 더 양보 — 서버 Puppeteer 가
				// waitForSelector 이후 곧바로 클론 캡처하면 빈 컨테이너가 찍히는 걸 방지.
				await this.$nextTick();
			} catch (e) {
				console.warn('Naver Maps script failed:', e);
			}

			// 추정가(AVM)는 best-effort — 지도/템플릿은 이미 렌더됐다. 상한 내에서만 더 기다린다.
			try {
				await Promise.race([
					estimateReady,
					new Promise(r => setTimeout(r, EST_READY_GATE_MS)),
				]);
			} catch (e) { /* graceful */ }

			// 서버 Puppeteer 대기 해제 — capIdList 와 지도 렌더 완료 이후 세팅.
			markReady();
		},
		getUser() {
			// F-6.2: init() 이 Promise.all 로 await 하므로 Promise 를 반환한다.
			// F-6.4: sibling fetcher(getRent/getFloor/getLand) 와 동일하게 .catch 로
			// reject 를 흡수한다. 없으면 /user/info 실패 시 Promise.all 이 reject →
			// init 이 loadSt=true 에 도달하지 못해 __VUE_READY__ 가 영구 false 가 되고
			// 서버 Puppeteer 가 타임아웃 → 사용자에게 빈 PDF 가 반환된다.
			return this.$apiGET('/admin/api/user/info').then(re => {
				this.userInfo = re || {};
			}).catch(e => { console.warn('getUser failed:', e); this.userInfo = {}; });
		},
		loadMap(item, id) {
			this.itemList[id].map_1 = new window.naver.maps.Map('map_1_' + id, {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 16,
			});
			this.itemList[id].map_1.setCenter({ lat: item.pt.y, lng: item.pt.x });
			this.itemList[id].map_1.setSize({ width: '550px', height: '690px' });
			this.itemList[id].marker_1 = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(item.pt.y, item.pt.x),
				map: this.itemList[id].map_1,
			});

			this.itemList[id].mapType = new window.naver.maps.CadastralLayer();

			this.itemList[id].map_2 = new window.naver.maps.Map('map_2_' + id, {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 18,
			});

			this.itemList[id].mapType.setMap(this.itemList[id].map_2);

			this.itemList[id].map_2.setCenter({ lat: item.pt.y, lng: item.pt.x });
			this.itemList[id].map_2.setSize({ width: '550px', height: '690px' });
			this.itemList[id].marker_2 = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(item.pt.y, item.pt.x),
				map: this.itemList[id].map_2,
			});
		},
		mainLoadMap(isItem) {
			let max = 0;
			let pt = { x: 0, y: 0 };
			for (let i = 0; i < isItem.idList.length; i++) {
				const pt1 = this.itemList[isItem.idList[i]].item.pt;
				pt.x += pt1.x;
				pt.y += pt1.y;
				if (isItem.idList.length > 0) {
					for (let ii = 1; ii < isItem.idList.length; ii++) {
						const pt2 = this.itemList[isItem.idList[ii]].item.pt;

						const dis = this.calDist(pt1.y, pt1.x, pt2.y, pt2.x);

						if (max < dis) {
							max = dis;
						}
					}
				} else {
					max = 100;
				}
			}

			let zoomLevel = null;
			if (max >= 50000) {
				zoomLevel = 8;
			} else if (30000 <= max && max < 50000) {
				zoomLevel = 9;
			} else if (20000 <= max && max < 30000) {
				zoomLevel = 10;
			} else if (10000 <= max && max < 20000) {
				zoomLevel = 11;
			} else if (5000 <= max && max < 10000) {
				zoomLevel = 12;
			} else if (3000 <= max && max < 5000) {
				zoomLevel = 13;
			} else if (1000 <= max && max < 3000) {
				zoomLevel = 14;
			} else if (500 <= max && max < 1000) {
				zoomLevel = 15;
			} else {
				zoomLevel = 16;
			}

			isItem.map = new window.naver.maps.Map(isItem.mapIdName, {
				center: new window.naver.maps.LatLng(pt.y / isItem.idList.length, pt.x / isItem.idList.length),
				zoom: zoomLevel,
			});

			for (let i = 0; i < isItem.idList.length; i++) {
				const pt = this.itemList[isItem.idList[i]].item.pt;

				let marker = new window.naver.maps.Marker({
					position: new window.naver.maps.LatLng(pt.y, pt.x),
					map: isItem.map,
				});

				marker.setIcon({
					icon: 'HtmlIcon',
					content: `<span class="pin color-${i + 1}"><span class="num">${i + 1}</span></span>`,
				});

				isItem.markerList.push(marker);
			}

			// isItem.map.setCenter({ lat: this.item.pt.y, lng: this.item.pt.x });
			isItem.map.setSize({ width: '550px', height: '500px' });
		},
		calDist(lat1, lon1, lat2, lon2) {
			let EARTH_R = 6371000.0;
			let rad = Math.PI / 180;
			let radLat1 = rad * lat1;
			let radLat2 = rad * lat2;
			let radDist = rad * (lon1 - lon2);

			let distance = Math.sin(radLat1) * Math.sin(radLat2);
			distance = distance + Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radDist);
			let ret = EARTH_R * Math.acos(distance);

			return Math.round(ret); // 미터 단위
		},
		async copyChartImg() {
			this.isPdfLoading = true;
			this.pdfLoadingMsg = '출력 준비 중...';
			this.pdfLoadingCurrent = 0;
			this.pdfLoadingTotal = 0;
			// F-5.1: progress callback passed to $exportPrint
			const onProgress = (current, total) => {
				this.pdfLoadingTotal = total;
				this.pdfLoadingCurrent = current;
				this.pdfLoadingMsg = total > 1
					? `출력 준비 중... (${current}/${total} 페이지)`
					: '출력 준비 중...';
			};
			try {
				// F-6.4: 출력로그 기록은 await 하되, 실패가 PDF 다운로드를 막지 않도록 격리.
				try {
					await this.$apiPOST('/admin/api/detail/item/print', { bidList: this.bidList });
				} catch (logErr) {
					console.warn('print log failed (non-blocking):', logErr);
				}
				try {
					this.syncEstimateToUrl(); // 편집 추정가를 URL 에 반영(서버 PDF 재로드 대비)
					this.syncInvestmentToUrl(); // 편집 투자분석 입력값을 URL 에 반영(서버 PDF 재로드 대비)
					this.rebuildCapIdList(); // ③④ 토글 후 capIdList 최신화(stale 셀렉터 hang 방지)
					await this.$exportPdf(this.capIdList, this.reportFileName());
				} catch (e) {
					console.warn('Server PDF failed, falling back to client-side:', e);
					await this.$exportPrint(this.capIdList, onProgress, this.reportFileName());
				}
			} finally {
				this.isPdfLoading = false;
				this.pdfLoadingMsg = '';
			}
		},
		estimateAreaPy(bid) {
			// 추정가 평면적(평): 로드 시 캡처한 AVM 일관면적(총액/평당), 평당0 이면 대지면적평 폴백
			const it = this.itemList[bid];
			if (!it || !it.estimate) return 0;
			if (it.estimate.areaPy > 0) return it.estimate.areaPy;
			const lp = Number(it.item && it.item.land_size_p);
			return Number.isFinite(lp) && lp > 0 ? lp : 0;
		},
		// 총액 수정 → 평당 자동연동(면적 기준)
		syncEstimatePyFromTotal(bid) {
			const it = this.itemList[bid];
			if (!it || !it.estimate) return;
			const area = this.estimateAreaPy(bid);
			if (area > 0) it.estimate.py = Math.round((Number(it.estimate.total) || 0) / area);
		},
		// 평당 수정 → 총액 자동연동(면적 기준)
		syncEstimateTotalFromPy(bid) {
			const it = this.itemList[bid];
			if (!it || !it.estimate) return;
			const area = this.estimateAreaPy(bid);
			if (area > 0) it.estimate.total = Math.round((Number(it.estimate.py) || 0) * area);
		},
		// 편집한 추정가/표시여부를 URL 에 실어 서버 PDF(Puppeteer 가 window.location.href 재로드) 에 반영. bid별 est_<bid>=총액_평당_표시.
		syncEstimateToUrl() {
			const u = new URL(window.location.href);
			[...u.searchParams.keys()].forEach(k => { if (k.indexOf('est_') === 0) u.searchParams.delete(k); });
			for (const bid of this.bidList) {
				const it = this.itemList[bid];
				if (it && it.estimate && it.estimate.available) {
					const t = Math.round(Number(it.estimate.total) || 0);
					const pp = Math.round(Number(it.estimate.py) || 0);
					u.searchParams.set('est_' + bid, t + '_' + pp + '_' + (it.showEstimate ? 1 : 0));
				}
			}
			window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
		},
		// 담당자 저장 추정가(DB, it.item.printDefaults) 를 AVM 위에 덮는다. URL(applyEstimateUrlOverride)이 다시 그 위.
		applyEstimateDefaults(bid) {
			const it = this.itemList[bid];
			if (!it || !it.item || !it.item.printDefaults) return;
			const pd = it.item.printDefaults;
			const t = Math.round(Number(pd.est_total));
			const pp = Math.round(Number(pd.est_py));
			if (Number.isFinite(t) && Number.isFinite(pp) && t >= 0 && pp >= 0 && (t > 0 || pp > 0)) {
				it.estimate = { available: true, total: t, py: pp, areaPy: pp > 0 ? t / pp : 0 };
			}
			if (pd.est_show != null) it.showEstimate = String(pd.est_show) !== '0';
		},
		// 서버 재로드 시 URL 의 bid별 편집 추정가/표시여부를 AVM 원본 위에 덮어쓴다.
		applyEstimateUrlOverride(bid) {
			const raw = this.$route.query['est_' + bid];
			if (!raw || !this.itemList[bid]) return;
			const parts = String(raw).split('_');
			const t = Math.round(Number(parts[0]));
			const pp = Math.round(Number(parts[1]));
			if (Number.isFinite(t) && Number.isFinite(pp) && t >= 0 && pp >= 0) {
				this.itemList[bid].estimate = { available: true, total: t, py: pp, areaPy: pp > 0 ? t / pp : 0 };
			}
			if (parts[2] != null && parts[2] !== '') this.itemList[bid].showEstimate = parts[2] !== '0';
		},
		// 명시적 est_show 지정(URL/DB)이 없을 때만: 블록 AI 추정가가 매매가보다 높으면 기본 활성화, 아니면 비활성화.
		applyEstimateShowDefault(bid) {
			const it = this.itemList[bid];
			if (!it) return;
			const pd = (it.item && it.item.printDefaults) ? it.item.printDefaults : {};
			const urlRaw = this.$route.query['est_' + bid];
			const urlParts = urlRaw != null ? String(urlRaw).split('_') : [];
			const hasUrlShow = urlParts[2] != null && urlParts[2] !== '';
			const hasDbShow = pd.est_show != null;
			if (hasUrlShow || hasDbShow) return; // 사용자(URL)/담당자(DB) 명시 선택 우선
			it.showEstimate = this.estimateAboveSellOf(bid);
		},
		// 블록 AI 추정가가 매매가보다 높은가? (기본 표시 여부의 기준) 추정가/매물 미로드 시 false.
		estimateAboveSellOf(bid) {
			const it = this.itemList[bid];
			if (!it || !it.estimate || !it.estimate.available) return false;
			const est = Number(it.estimate.total) || 0;
			const sell = Number(it.item && it.item.sell_price) || 0;
			return est > 0 && sell > 0 && est > sell;
		},
		// 추정가(AVM) 매물별 로드. bid 루프 → 백엔드 프록시. graceful: 실패 시 estimate.available=false 유지.
		async getEstimate() {
			// P2(codex): bid 별 직렬 await 는 외부 AVM 지연(EXT_API_TIMEOUT_MS=8s) × bid 수
			//   만큼 누적돼 다중매물 비교 PDF 의 ready 예산(30s)을 초과할 수 있다. 병렬 fetch.
			await Promise.all(this.bidList.map(async (bid) => {
				if (!this.itemList[bid]) return;
				try {
					const data = await this.$apiGET('/admin/api/detail/item/estimate?bid=' + bid);
					if (data && data.available) {
						const _t = Math.round((Number(data.totalKrw) || 0) / 10000);
						const _p = Math.round((Number(data.pyUnit) || 0) / 10000);
						this.itemList[bid].estimate = { available: true, total: _t, py: _p, areaPy: _p > 0 ? _t / _p : 0 }; // AVM 원→만원; areaPy=평면적(총액/평당) 연동기준
					}
				} catch (e) { /* graceful: estimate.available 기본 false 유지 */ }
				this.applyEstimateDefaults(bid);    // 담당자 저장 추정가(DB) — AVM 위, URL 아래
				this.applyEstimateUrlOverride(bid); // 편집 추정가(URL) 적용 — AVM 성패 무관
				this.applyEstimateShowDefault(bid); // 명시 지정 없으면: 추정가>매매가일 때만 기본 활성화
			}));
		},
		async getItem() {
			// F-6.3: $apiGET 은 400/네트워크 실패 시 boolean `false` 를 반환한다(seon.js 참조).
			// 과거엔 그대로 `data.img = null` 을 건드려 TypeError 로 init 이 멈추고
			// loadSt 가 true 로 세팅되지 못해 DOM 이 영영 렌더되지 않았다.
			// 실패한 bid 는 failedBids 에 모아 itemList/bidList 에서 제거하고,
			// 전부 실패한 경우에만 alert + throw 로 명시적으로 중단한다.
			const failedBids = [];
			for (let i = 0; i < this.bidList.length; i++) {
				const bid = this.bidList[i];

				const data = await this.$apiGET('/admin/api/detail/item?bid=' + bid + '&isRent=false');

				if (!data || typeof data !== 'object') {
					console.warn('getItem failed for bid', bid, '→ skipping');
					failedBids.push(bid);
					continue;
				}

				for (let prop in data) {
					if (data[prop] == null) {
						data[prop] = '';
					}
				}

				data.img = null;

				//썸네일
				for (let i = 0; i < data.imgList.length; i++) {
					if (data.imgList[i]) {
						data.img = process.env.VUE_APP_HOST_BACK + '/users/item/image?id=' + data.imgList[i] + '&w=1200&q=82';
						break;
					}
				}

				//이미지 리스트
				let imgObjList = [];
				for (let i = 0; i < data.imgList.length; i++) {
					if (data.imgList[i]) {
						imgObjList.push({
							// I1: 사용자 라벨 우선, fallback IMG_NAME.
							name: (data.imgLabels && data.imgLabels[i] && data.imgLabels[i].length) ? data.imgLabels[i] : this.$IMG_NAME[i],
							img: process.env.VUE_APP_HOST_BACK + '/users/item/image?id=' + data.imgList[i] + '&w=1200&q=82',
							st: true,
						});
					}
				}

				data.imgObjList = imgObjList;

				let imgObj = [];
				for (let i = 0; i < imgObjList.length; i += 2) {
					imgObj.push(imgObjList.slice(i, i + 2));
				}

				data.imgObj = imgObj;

				this.itemList[bid].item = data;

				// F-5.2: fallback — use building's own address until land parcels load
				// F-2.1: legacy row 방어선 — 원시 "서울특별시 … 번지" 포맷도 정규화.
				if (!this.itemList[bid].coverAddr) {
					const fallback = normalizeAddr(data.jibun_addr);
					this.itemList[bid].coverAddr = fallback;
					this.itemList[bid].bodyAddr = fallback;
				}
			}

			// F-6.3: 실패한 bid 는 렌더 루프/지도 생성에서 제외하고 itemList 엔트리도 제거.
			// 전부 실패했다면 더 진행해도 빈 페이지만 찍히므로 명시적으로 중단.
			if (failedBids.length > 0) {
				for (const fb of failedBids) {
					delete this.itemList[fb];
				}
				this.bidList = this.bidList.filter(b => !failedBids.includes(b));
				if (this.bidList.length === 0) {
					alert('매물 정보를 불러오지 못했습니다.');
					throw new Error('getItem: all bids failed');
				}
				// isBid 가 실패 bid 를 가리키고 있으면 첫 성공 bid 로 재지정.
				if (failedBids.includes(this.isBid)) {
					this.isBid = this.bidList[0];
				}
			}

			this.itemGroup = [];
			for (let i = 0; i < this.bidList.length; i += 3) {
				this.itemGroup.push({
					idList: this.bidList.slice(i, i + 3),
					domIdName: 'capdom_' + i,
					mapIdName: 'mainMap_' + i,
					map: null,
					markerList: [],
				});
			}

			this.capIdList = [];

			// F-6.4: indexList 재생성 — updateId() 와 동일 로직을 buildIndexList() 로 공유.
			this.indexList = this.buildIndexList();

			// F-6.2: capIdList 수집·__VUE_READY__·지도 렌더는 init() 으로 이동.
			// loadSt=true 이후의 $nextTick 에서만 DOM 이 보장되기 때문.
		},
		// F-6.4: getItem / updateId 두 곳에서 동일했던 indexList 재생성 루프를
		// 단일 메서드로 추출. 호출자는 `this.indexList = this.buildIndexList();`
		// 형태로 대입해 사용한다. 출력 문구(비교/물건개요/.../END)와 인덱스
		// 포맷(`'0' + idx + '. '`)은 기존 동작과 byte-identical.
		buildIndexList() {
			const list = [];
			let idx = 1;
			for (let i = 1; i < this.opList.length; i++) {
				if (this.opList[i]) {
					if (i == 1) {
						list.push({
							idx: '0' + idx + '. ',
							name: '비교',
						});
					} else if (i == 2) {
						list.push({
							idx: '0' + idx + '. ',
							name: '물건개요',
						});
					} else if (i == 3) {
						list.push({
							idx: '0' + idx + '. ',
							name: '임대정보',
						});
					} else if (i == 4) {
						list.push({
							idx: '0' + idx + '. ',
							name: '건축물정보',
						});
					} else if (i == 5) {
						list.push({
							idx: '0' + idx + '. ',
							name: '건축 내/외부 사진',
						});
					} else if (i == 6) {
						list.push({
							idx: '0' + idx + '. ',
							name: '지도',
						});
					} else if (i == 7) {
						list.push({
							idx: '0' + idx + '. ',
							name: 'END',
						});
					}
					idx++;
				}
			}
			return list;
		},
		updateId() {
			for (let i = 0; i < this.bidList.length; i++) {
				const bid = this.bidList[i];

				let data = JSON.parse(JSON.stringify(this.itemList[bid].item));

				//이미지 리스트
				let imgObjList = [];
				for (let i = 0; i < data.imgObjList.length; i++) {
					if (data.imgObjList[i].st) {
						imgObjList.push(data.imgObjList[i]);
					}
				}

				let imgObj = [];
				for (let i = 0; i < imgObjList.length; i += 2) {
					imgObj.push(imgObjList.slice(i, i + 2));
				}

				this.itemList[bid].item.imgObj = imgObj;
			}

			this.$nextTick(() => {
				// F-6.4: getItem() 과 동일 로직을 buildIndexList() 공유 메서드로 위임.
				this.indexList = this.buildIndexList();

				markStage('dom-rendered');
				this.capIdList = this.collectCaptureIds();

				if (this.opList[1]) {
					for (let i = 0; i < this.itemGroup.length; i++) {
						this.mainLoadMap(this.itemGroup[i]);
					}
				}
			});
		},
		getRent() {
			// F-6.2: init() 이 Promise.all 로 await 하도록 Promise.all 반환.
			const promises = this.bidList.map(bid => {
				return this.$apiGET('/admin/api/detail/item/rent?bid=' + bid).then(data => {
					// F-6.3: $apiGET 실패 시 false 가 반환될 수 있다 → 빈 배열로 대체.
					if (!Array.isArray(data)) data = [];
					let m2 = 0;
					let py = 0;
					let deposit = 0;
					let money = 0;
					let mgr = 0;

					let cnt = data.length;
					let sumCnt = 0;

					for (let i = 0; i < data.length; i++) {
						if (data[i].rent_money) {
							sumCnt++;
						}

						// 면적은 항상 합산 (F-3.4)
						m2 += Number(data[i].rent_size_m2);
						py += Number(data[i].rent_size_p);
						if (data[i].except_flag != 'Y') {
							deposit += Number(data[i].rent_deposit);
							money += Number(data[i].rent_money);
							mgr += Number(data[i].mgr_fee);
						}
					}

					if (cnt) {
						this.itemList[bid].rentRate.datasets[0].data[0] = Number(((sumCnt / cnt) * 10 * 10).toFixed(2));
					} else {
						this.itemList[bid].rentRate.datasets[0].data[0] = 0;
					}

					const rentGroup = this.$groupBy(data, 'rent_usage');
					for (let prop in rentGroup) {
						const curCnt = rentGroup[prop].length;
						this.itemList[bid].rentRateList.datasets.push({
							label: prop,
							data: [Number(((curCnt / cnt) * 100).toFixed(2))],
						});
					}

					this.itemList[bid].rentRateSt = true;
					this.itemList[bid].rentRateListSt = true;

					this.itemList[bid].rentList = data;
					this.itemList[bid].totalData.m2 = m2.toFixed(2);
					this.itemList[bid].totalData.py = py.toFixed(2);
					this.itemList[bid].totalData.deposit = deposit;
					this.itemList[bid].totalData.money = money;
					this.itemList[bid].totalData.mgr = mgr;
					this.itemList[bid].totalData.rent_ni = (
						Number(this.itemList[bid].totalData.money) / Number(this.itemList[bid].totalData.py)
					).toFixed(2);
				}).catch(e => { console.warn('getRent failed for bid', bid, e); });
			});
			return Promise.all(promises);
		},
		getFloor() {
			// F-6.2: init() 이 Promise.all 로 await 하도록 Promise.all 반환.
			const promises = this.bidList.map(bid => {
				return this.$apiGET('/admin/api/detail/item/floor?bid=' + bid).then(data => {
					// F-6.3: $apiGET 실패 시 false 가능 → 빈 배열로 대체.
					if (!Array.isArray(data)) data = [];
					let m2 = 0;
					let py = 0;

					for (let i = 0; i < data.length; i++) {
						// 건축물대장이 면적 제외로 표시한 행(옥탑 계단실 등)은 연면적에 들지 않는다(DD). 담당자 제외 체크와는 별개다.
						if (String(data[i].areaExctYn) === '1') continue;
						m2 += Number(data[i].area_m2);
						py += Number(data[i].area_py);
					}

					this.itemList[bid].floorList = data;
					this.itemList[bid].totalFloorData.m2 = m2.toFixed(2);
					this.itemList[bid].totalFloorData.py = py.toFixed(2);
				}).catch(e => { console.warn('getFloor failed for bid', bid, e); });
			});
			return Promise.all(promises);
		},
		getLand() {
			const promises = this.bidList.map(bid => {
				return this.$apiGET('/admin/api/detail/item/edit/land?bid=' + bid).then(data => {
					// F-2.1: legacy row 방어선 — 렌더 직전에 정규화.
					// F-6.3: $apiGET 실패 시 false 가능 → fallback 유지.
					if (!Array.isArray(data)) return;
					const uniqueAddrs = [...new Set(
						data.map(d => normalizeAddr(d.jibun_addr)).filter(Boolean)
					)];
					if (uniqueAddrs.length > 1) {
						this.itemList[bid].coverAddr = uniqueAddrs[0] + ' 외 ' + (uniqueAddrs.length - 1) + '필지';
					} else if (uniqueAddrs.length === 1) {
						this.itemList[bid].coverAddr = uniqueAddrs[0];
					}
					// F-5.2: 본문은 시/구 제거 + 동일 동 반복 생략 포맷.
					this.itemList[bid].bodyAddr = formatBodyAddr(uniqueAddrs) || this.itemList[bid].coverAddr;
				}).catch(() => { /* fallback already set for this bid */ });
			});
			return Promise.all(promises);
		},
		setAllCheck() {
			for (let i = 0; i < this.opList.length; i++) {
				this.opList[i] = this.opAll;
			}
			this.updateId();
		},
	},
};
</script>

<style lang="scss" scoped>
// 배치출력 물건개요 — PrintPage.vue 의 dense-report 레이아웃 미러링 (레퍼런스 V07 정밀 재현).
.print-section.flex.property-overview {
	display: flex !important;
	flex-direction: column;
	position: relative;
	padding: 56px 40px 36px !important;
	box-sizing: border-box;
	background: #fbf9f3;
	height: 820px;
	overflow: hidden;

	.overview-header {
		position: absolute;
		top: 22px;
		left: 40px;
		right: 40px;
		display: flex;
		align-items: center;
		gap: 24px;
		padding-bottom: 10px;
		color: #8a8680;
		border-bottom: 1px solid rgba(138, 134, 128, 0.36);

		.overview-caption {
			font-size: 13px;
			letter-spacing: 0.42em;
			text-transform: uppercase;
			font-weight: 500;
			white-space: nowrap;
		}
		.overview-line {
			flex: 1 1 auto;
			height: 0;
		}
		.overview-brand {
			flex: 0 0 auto;
			width: 108px;
			height: 24px;
			background: url(../assets/images/weonus_wordmark_bk.png) no-repeat right center / contain;
		}
	}

	// Summary 제목 밴드 — overview-left 안에 위치, 폰트 축소로 height 감소
	.overview-title-band {
		display: flex;
		align-items: baseline;
		flex-wrap: nowrap;
		gap: 8px;
		margin: 0 0 6px;
		overflow: hidden;

		.title-main {
			font-size: 18px;
			font-weight: 800;
			color: #1a1714;
			letter-spacing: -0.025em;
			line-height: 1.1;
			white-space: nowrap;
		}
		.title-slash {
			font-size: 15px;
			font-weight: 200;
			color: #cfc7b9;
			line-height: 1;
			padding: 0 1px;
		}
		.title-addr {
			font-size: 11px;
			font-weight: 400;
			color: #8a8680;
			letter-spacing: 0.005em;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			flex: 0 1 auto;
			min-width: 0;
		}
	}

	// overview-main: 좌(Summary + 메트릭 + 3 테이블) | 우(사진 + 특징) — PrintPage 와 동일한
	// 50:50 분할, gap 16px. 이전 48/51 + margin-right:-40px 는 우측 사진이 페이지 우측 padding
	// (40px) 을 잠식하며 경계를 넘어 잘려 보이는 원인이었음.
	.overview-main {
		flex: 1 1 auto;
		display: flex;
		flex-direction: row;
		gap: 16px;
		min-height: 0;
		margin-top: 6px; // overview-header(absolute) 와의 안전 마진
	}
	.overview-left {
		flex: 1 1 50%;
		min-width: 0;
		display: flex;
		flex-direction: column;
	}
	.overview-right {
		flex: 1 1 50%;
		min-width: 0;
		display: flex;
		flex-direction: column;
		align-self: stretch;
	}

	// 본문 좌측 스택: 금액정보 → 토지정보 → 건축정보 세로 배치
	.body-stack {
		flex: 1 1 auto;
		display: flex;
		flex-direction: column;
		gap: 10px;
		min-height: 0;
	}
	.area-amt, .area-land, .area-bldg {
		min-width: 0;
		display: flex;
		flex-direction: column;
	}

	// 특징 (우측 하단) — 사진 바로 아래에 top-anchored 로 붙고 콘텐츠 분량 만큼 아래로
	// 확장. flex:0 1 auto 로 잔여 column 높이를 흡수하지 않음(이전 1 1 auto 는 features 가
	// column 최하단에 붙는 결과 → 사진과 사이에 큰 빈 공간 발생).
	.area-feat {
		flex: 0 1 auto;
		min-width: 0;
		display: flex;
		flex-direction: column;
	}

	// 사진 — width 100% + 7:8 (width:height) 세로형 비율. 원본(flex:1 1 auto 잔여 흡수 시
	// ~590px) 과 유사한 시각 크기 유지. flex:0 1 auto + min-height:0 으로 특징이 길 때
	// 사진이 자연스럽게 살짝 줄어들 수 있도록 함. (4:3 으로 했더니 사진이 너무 작아 보였다는
	// 피드백 반영)
	.overview-right .right-photo {
		width: 100%;
		position: relative;
		background-color: #f2eeea;
		border-radius: 0;
		overflow: hidden;
		flex: 0 1 auto;
		aspect-ratio: 7 / 8;
		min-height: 0;

		&.right-photo-square {
			// 베이스 7:8 그대로 — square 변형 override 제거.
			aspect-ratio: 7 / 8;
			height: auto;
		}

		.right-photo-img {
			width: 100%;
			height: 100%;
			// "안잘리게" — 어떤 비율의 건물 사진이라도 크롭 없이 전체가 보이도록 contain.
			object-fit: contain;
			display: block;
		}

		.right-caption {
			position: absolute;
			left: 10px;
			bottom: 10px;
			padding: 4px 10px;
			background: rgba(255, 255, 255, 0.92);
			font-size: 11px;
			color: #3c3a36;
			letter-spacing: 0.04em;
			border-radius: 0;
			z-index: 2;
			white-space: nowrap;
		}
	}

	.metric-bar {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		background: #7a1c1c;
		color: #fbf9f3;
		padding: 6px 0;
		margin: 0 0 8px;
		border-radius: 0;
		flex: 0 0 auto;
		// 4셀 모두 동일 14px value 폰트 + 길면 줄바꿈 허용 → 셀 폭 91px 안에서 잘려도
		// '...' 으로 표시되지 않도록 한다. 2줄 wrap + sub 까지 들어가는 worst case
		// (주변역) 가 약 60px content 가 필요하므로 bar 높이를 76px 로 확장.
		height: 76px;
		box-sizing: border-box;

		.metric {
			padding: 8px 6px 0;
			box-sizing: border-box;
			border-right: 1px solid rgba(251, 249, 243, 0.2);
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 1px;
			height: 100%;
			min-width: 0;
			// 첫 셀(매매금액) 은 burgundy bar 좌단과 너무 붙지 않도록 살짝 더 띄움.
			&:first-child { padding-left: 14px; }
			&:last-child { border-right: none; }

			.metric-label {
				font-size: 9px;
				letter-spacing: 0.18em;
				color: rgba(251, 249, 243, 0.72);
				font-weight: 500;
				text-transform: uppercase;
				white-space: nowrap;
				line-height: 1.2;
			}
			.metric-value {
				font-size: 14px;
				font-weight: 800;
				color: #fbf9f3;
				line-height: 1.15;
				letter-spacing: -0.02em;
				// '...' truncation 금지 — 셀 폭 안에서 wrap 으로 풀어 2줄까지 허용.
				white-space: normal;
				word-break: keep-all;
				overflow-wrap: anywhere;
				max-width: 100%;
			}
			.metric-sub {
				display: block;
				font-size: 8.5px;
				color: rgba(251, 249, 243, 0.62);
				letter-spacing: 0.03em;
				font-weight: 400;
				line-height: 1.2;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				max-width: 100%;
			}
		}
	}

	// 섹션 헤더 — PrintPage(.left .bottom .section-tit--print-header) 와 동일한
	// 클래식 #a23334 헤더 + 작은 둥근 모서리.
	.section-tit--print-header {
		background-color: #a23334;
		color: #fff !important;
		border-color: #a23334 !important;
		padding: 4px 10px;
		border-radius: 2px;
	}
	// body-stack 내부 — 첫 헤더는 위 마진 0, 나머지는 6/4 (PrintPage `.left .bottom` 동일).
	.body-stack {
		.section-tit--print-header {
			margin-top: 6px;
			margin-bottom: 4px;
			font-size: 13px;
			&:first-child { margin-top: 0; }
		}
	}
	// 우측 특징 헤더만 별도 — features-header 는 cream 배경 + burgundy 글자.
	.area-feat .section-tit--print-header.features-header {
		background-color: #fbf9f3 !important;
		color: #791b1c !important;
		border: 1px solid #ede3d1 !important;
		border-bottom: 2px solid #791b1c !important;
		padding: 3px 12px !important;
		font-size: 12px;
		border-radius: 0 !important;
	}

	// 본문 좌측 3 테이블 — PrintPage 의 .left .bottom .table.compact 동일 (padding 2/8,
	// font 11.5, line-height 1.25). Bootstrap float-start/float-end 그대로 사용 (이전
	// 96px padding + absolute float-end override 제거 — 값이 우측으로 밀려 보이던 문제 해결).
	.body-stack .table.compact {
		margin-bottom: 0;
		th, td {
			padding: 2px 8px;
			font-size: 11.5px;
			line-height: 1.25;
		}
		th { font-weight: 500; }
		th.txt-c--red, td.txt-c--red { font-weight: 700; }
	}

	// 특징 — 01/02/03 넘버링 (red monospace, 에디토리얼)
	.area-feat .features-list,
	.features-row .features-list,
	.features-list {
		box-sizing: border-box;
		background: #fbf9f3;
		border: 1px solid #ede3d1;
		border-top: none;
		border-radius: 0;
		padding: 12px 16px;
		margin: 0;
		list-style: none;
		font-size: 11.5px;
		line-height: 1.5;
		color: #2c2a27;
		counter-reset: feat;

		li {
			position: relative;
			padding: 0 0 6px 26px;
			margin: 0;
			counter-increment: feat;
			white-space: normal;
			word-break: keep-all;
			&:last-child { padding-bottom: 0; }

			&::before {
				content: counter(feat, decimal-leading-zero);
				position: absolute;
				left: 0;
				top: 1px;
				color: #dc3545;
				font-weight: 700;
				font-size: 10px;
				letter-spacing: 0.08em;
				font-variant-numeric: tabular-nums;
				line-height: 1.7;
			}
		}
	}

	// features-list — 콘텐츠 분량 만큼만 차지(flex:0 0 auto). 이전 1 1 auto 는 잔여 높이를
	// 흡수해 사진 아래 시작점이 모호해지던 문제 원인.
	.area-feat .features-list {
		flex: 0 0 auto;
		display: flex;
		flex-direction: column;
	}
}

// ③④ 추정가 배지/저평가 비교 (PrintPage 와 동일 스타일 — estimate emphasis).
.estimate-note-row td { background: transparent; }
.estimate-note-text-static { font-size: 9px; color: #555; line-height: 1.3; display: inline; white-space: nowrap; padding: 0; background: transparent; vertical-align: middle; }
.note-badge { display: inline-block; background: #6b7280; color: #fff; font-size: 8px; font-weight: 700; padding: 1px 5px; border-radius: 10px; margin-right: 4px; vertical-align: middle; }
.estimate-badge { display: inline-block; padding: 2px 9px; border-radius: 12px; font-size: 12px; font-weight: 700; margin-left: 8px; vertical-align: middle; }
.estimate-badge--under { background: #1f8a4c; color: #fff; }
.estimate-badge--premium { background: #1f8a4c; color: #fff; }
.estimate-badge--equal { background: #888; color: #fff; }
.sell-compare { font-size: 12px; color: #1f8a4c; font-weight: 600; }

// 2페이지 이후 모든 페이지 하단의 법적 고지 (회색·9px·2줄). `.print-section`(전역 position:relative)
// 내부에 absolute 배치 — watermark(::after, z-index:5) 위로 올라오도록 z-index:6.
.page-footer-disclaimer {
	position: absolute;
	left: 24px;
	right: 24px;
	bottom: 6px;
	z-index: 6;
	padding: 3px 6px 2px;
	background: rgba(255, 255, 255, 0.92);
	border-top: 1px solid rgba(0, 0, 0, 0.05);
	font-size: 7.5px;
	line-height: 1.45;
	color: #6b6b6b;
	letter-spacing: -0.01em;
	pointer-events: none;
	p {
		margin: 0;
		text-indent: -6px;
		padding-left: 6px;
		word-break: keep-all;
	}
	p + p { margin-top: 1px; }
}
// 표지 직후 첫 본문(property-overview)은 배경이 #fbf9f3 — footer 배경을 같은 톤으로.
.print-section.property-overview .page-footer-disclaimer {
	background: rgba(251, 249, 243, 0.95);
	border-top-color: rgba(122, 28, 28, 0.08);
}

// F-3.5 제외 row 연회색 처리 스타일은 assets/css/common.scss 로 이동 (전역 단일 정의).

// COMPARABLE(.flex2-1) — 16행(빌딩명, 사진, 소재지, 매매금액, 대지면적, 연면적, 건축면적,
// 건폐율, 용적률, 준공년도, 규모, 주용도, 엘리베이터, 주차대수, 역, 역과의 거리) 가 모두
// .print-section 820px 안에 들어가도록 셀 padding 을 축소하고 사진 셀 높이를 제한.
// 기존 padding 7px 10px(.print-section .table 전역) + 사진 셀이 column 폭 비례 height
// (portrait 사진의 경우 ~250px) 까지 늘어나면서 마지막 '역과의 거리' 행이 페이지 하단을
//넘어 잘리는 문제 해결.
.print-section.flex2-1 {
	.left .table.type-input {
		th, td {
			padding: 3px 8px;
			line-height: 1.3;
		}
		// 사진 셀 — 셀 자체 padding 0 (.print-section .table td.img 글로벌과 동일) +
		// 이미지 max-height 로 portrait 사진이 행을 키우는 것을 방지.
		td.img {
			padding: 0;
			img {
				width: 100%;
				max-height: 130px;
				object-fit: cover;
				display: block;
			}
		}
	}
}

.pdf-loading-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
}
.pdf-loading-spinner {
	background: white;
	padding: 30px 50px;
	border-radius: 8px;
	font-size: 18px;
	font-weight: bold;
	min-width: 260px;
	text-align: center;
}
.pdf-loading-text {
	margin-bottom: 14px;
}
.pdf-loading-bar-wrap {
	width: 100%;
	height: 8px;
	background: #e0e0e0;
	border-radius: 4px;
	overflow: hidden;
}
.pdf-loading-bar {
	height: 100%;
	background: #1976d2;
	border-radius: 4px;
	transition: width 0.25s ease;
}

/* =========================================================
 * 표지(cover) 3 variant — 레퍼런스 정밀 재현
 *   - 페이퍼 텍스처, 2-tone 레드, 3-band 레이아웃, 가는 라인 모티브
 * ========================================================= */

// 제휴 게스트(신한/대신) 표지: 위온어스 단독 워드마크 → 위온어스×기관 공동로고 흰 카드.
// 공동로고는 배경색에 맞춘 투명배경 png 사용(받침 없음):
//   밝은 배경(V01 near-white / V05 흰카드) → -color (we'onus 검정 + 은행 컬러)
//   어두운 배경(V02 버건디) → -white (we'onus 흰색 + 은행 흰색 역상)
// 영역에 background-size:contain 으로 맞추고 position 은 variant 별 지정.
@mixin cover-cobrand-logo {
	background-repeat: no-repeat;
	background-size: contain;
}

// 페이퍼 그레인 텍스처 (레퍼런스 배경 노이즈 재현)
// V01/V02/V05 한정. V00 (Classic, cover-00)은 common.scss 의 글로벌 `.print-section.cover` 스타일을
// 그대로 사용해야 하므로 :not(.cover-00) 으로 제외 — 이 블록의 align/.tit/.logo 강제 숨김이 V00 에 적용되면 안 됨.
.print-section.cover[class*='cover-0']:not(.cover-00) {
	position: relative;
	padding: 0;
	overflow: hidden;
	// common.scss 의 `.print-section.cover { align-items:center; justify-content:center; }` 오버라이드.
	align-items: stretch !important;
	justify-content: flex-start !important;

	:deep(.logo),
	.logo { display: none !important; }
	:deep(.tit),
	.tit { display: none !important; }

	// ===== 공통 컴포넌트 =====
	.cover-caption {
		font-size: 13px;
		letter-spacing: 0.34em;
		text-transform: uppercase;
		font-weight: 500;
		white-space: nowrap;
	}
	.cover-title {
		line-height: 1.06;
		font-weight: 800;
		margin: 0;
		word-break: keep-all;
		letter-spacing: -0.01em;
		white-space: pre-line;
	}
	.cover-addr {
		font-size: 14px;
		letter-spacing: 0.04em;
	}
	.cover-wordmark {
		width: 130px;
		height: 26px;
		background: url(../assets/images/weonus_wordmark_bk.png) no-repeat center / contain;
		flex: 0 0 auto;
	}
	.cover-paper {
		position: absolute;
		inset: 0;
		background: url(../assets/images/paper_texture.png);
		background-repeat: repeat;
		mix-blend-mode: multiply;
		opacity: 0.6;
		pointer-events: none;
		z-index: 1;
	}
	.cover-split {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: stretch;
		z-index: 2;
	}

	// ===== Variant 01: Editorial (near-white 캔버스 + 우측 full-height 사진) =====
	// PIL 픽셀 측정(ref 1536×1024), x scale=0.7617, y scale=0.8008
	&.cover-01 {
		background: #fbfaf5;
		color: #3c3a36;
		.cover-paper { opacity: 0.18; }

		.cover-caption {
			position: absolute;
			top: 75px;
			left: 129px;
			color: #86867f;
			font-weight: 400;
			font-size: 16px;
			letter-spacing: 0.42em;
			z-index: 3;
		}
		.cover-top-line {
			position: absolute;
			top: 123px;
			left: 53px;
			right: 55px;
			height: 1px;
			background: #cac4b4;
			z-index: 3;
		}
		.cover-vstripe {
			position: absolute;
			top: 123px;
			bottom: 0;
			left: 713px;
			width: 13px;
			background: #8d271f;
			z-index: 4;
		}
		.cover-photo-box {
			position: absolute;
			top: 123px;
			left: 726px;
			right: 0;
			bottom: 0;
			overflow: hidden;
			background: #e0dbce;
			z-index: 2;

			.cover-photo {
				width: 100%;
				height: 100%;
				object-fit: cover;
				display: block;
			}
		}
		.cover-title {
			position: absolute;
			top: 183px;
			left: 129px;
			max-width: 420px;
			font-size: 60px;
			color: #8d271f;
			letter-spacing: -0.012em;
			line-height: 1.15;
			z-index: 3;
			margin: 0;
			// 공백 기준 자동 줄바꿈 (Korean keep-all)
			word-break: keep-all;
			word-spacing: 9999px;
		}
		.cover-addr-pill {
			position: absolute;
			top: 384px;
			left: 128px;
			height: 40px;
			padding: 0 20px;
			display: inline-flex;
			align-items: center;
			background: transparent;
			color: #6b6761;
			font-size: 13px;
			letter-spacing: 0.04em;
			border: 1px solid #d2ccbd;
			border-radius: 20px;
			z-index: 3;
			white-space: nowrap;
		}
		.cover-wordmark {
			position: absolute;
			top: 636px;
			left: 126px;
			width: 118px;
			height: 26px;
			z-index: 3;
		}
		.cover-bottom-line-l {
			position: absolute;
			top: 650px;
			left: 30px;
			width: 71px;
			height: 1px;
			background: #cac4b4;
			z-index: 2;
		}
		.cover-bottom-line-r {
			position: absolute;
			top: 650px;
			left: 269px;
			width: 426px;
			height: 1px;
			background: #cac4b4;
			z-index: 2;
		}
		// disclaimer — 빨간 글자 (테두리 없이, 사용자 요청으로 크게)
		.cover-disclaimer {
			position: absolute;
			top: 690px;
			left: 53px;
			width: 640px;
			padding: 0;
			border: none;
			color: #9c252f;
			font-size: 13px;
			line-height: 1.5;
			letter-spacing: 0.005em;
			word-break: keep-all;
			word-spacing: 0.06em;
			z-index: 4;
		}
		// 제휴 게스트 공동로고 — near-white 배경 → 컬러(투명배경) 로고, 받침 없음. flanking line 숨김.
		&.shinhan,
		&.daishin {
			.cover-bottom-line-l,
			.cover-bottom-line-r { display: none; }
			.cover-wordmark {
				@include cover-cobrand-logo;
				background-position: left center;
				top: 632px;
				left: 129px;
				right: 457px;
				width: auto;
				height: 34px;
			}
		}
		&.shinhan .cover-wordmark { background-image: url(../assets/partner/cobrand-shinhan-color.png); }
		&.daishin .cover-wordmark { background-image: url(../assets/partner/cobrand-daishin-color.png); }
	}

	// ===== Variant 02: Bold Burgundy — 3-band 절대 좌표 배치 =====
	// PIL 픽셀 측정(ref 1536×1024), scale x=0.7617 y=0.8008
	&.cover-02 {
		background: #9c252f;

		.cover-top-strip {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			height: 112px;
			background: #fbfaf5;
			z-index: 5;

			.cover-caption {
				position: absolute;
				top: 54px;
				left: 87px;
				color: #8a2128;
				font-weight: 500;
				font-size: 18px;
				letter-spacing: 0.44em;
			}
		}

		.cover-main {
			position: absolute;
			top: 112px;
			left: 0;
			right: 0;
			bottom: 134px; // 하단 cream strip 자리 (ref y=856~1024 → h=134)
			color: #f4e6d4;
			background: #9c252f;
			box-shadow:
				inset 120px 0 160px -100px rgba(40, 8, 10, 0.45),
				inset 0 40px 80px -50px rgba(40, 8, 10, 0.30);

			.cover-paper { opacity: 0.25; }

			.cover-vdecor-w1 {
				position: absolute;
				top: 0;
				bottom: 0;
				left: 646px;
				width: 2px;
				background: #fbfaf5;
				z-index: 3;
			}
			.cover-vdecor-dark {
				position: absolute;
				top: 0;
				bottom: 0;
				left: 648px;
				width: 66px;
				background: #6b151b;
				z-index: 3;
			}
			.cover-vdecor-w2 {
				position: absolute;
				top: 0;
				bottom: 0;
				left: 714px;
				width: 2px;
				background: #fbfaf5;
				z-index: 3;
			}
			.cover-photo-box {
				position: absolute;
				top: 0;
				left: 716px;
				right: 0;
				bottom: 0;
				overflow: hidden;
				background: #7d2627;

				.cover-photo {
					width: 100%;
					height: 100%;
					object-fit: cover;
					display: block;
				}
			}
			.cover-title {
				position: absolute;
				top: 110px;
				left: 88px;
				right: 546px;
				font-size: 64px;
				color: #fff;
				letter-spacing: -0.005em;
				line-height: 1.12;
				margin: 0;
				z-index: 2;
				font-weight: 800;
			}
			.cover-addr {
				position: absolute;
				top: 340px;
				left: 98px;
				color: rgba(244, 230, 212, 0.92);
				font-size: 14px;
				letter-spacing: 0.05em;
				z-index: 2;
			}
			// wordmark — ref y=802~820 → main-rel 530
			.cover-wordmark {
				position: absolute;
				top: 530px;
				left: 89px;
				width: 115px;
				height: 26px;
				background-image: url(../assets/images/weonus_wordmark_wh.png);
				background-size: contain;
				background-repeat: no-repeat;
				z-index: 2;
			}
			// wordmark 양옆 flanking 하얀 가로줄 — ref y=809 → main-rel 536
			.cover-bottom-line-l {
				position: absolute;
				top: 542px;
				left: 42px;
				width: 27px;
				height: 2px;
				background: #fbfaf5;
				z-index: 3;
			}
			.cover-bottom-line-r {
				position: absolute;
				top: 542px;
				left: 214px;
				width: 501px;
				height: 2px;
				background: #fbfaf5;
				z-index: 3;
			}
		}

		// 하단 cream strip — 본문 burgundy 아래, 본문과 경계 자연스러운 hard edge
		// ref y=856~1024 → y=686~820 (h=134)
		.cover-bottom-strip {
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			height: 134px;
			background: #fbfaf5;
			z-index: 5;

			// disclaimer — 크림 strip 내부 빨간 글자 (테두리 제거 + 크기 확대)
			.cover-disclaimer {
				position: absolute;
				top: 14px;
				left: 88px;
				right: 88px;
				bottom: 14px;
				padding: 0;
				border: none;
				color: #9c252f;
				font-size: 13px;
				line-height: 1.5;
				letter-spacing: 0.005em;
				word-break: keep-all;
				word-spacing: 0.08em;
				display: flex;
				align-items: center;
			}
		}
		// 제휴 게스트 공동로고 — 버건디 배경 → 흰색 역상(투명배경) 로고, 받침 없음. flanking line 숨김.
		&.shinhan,
		&.daishin {
			.cover-main {
				.cover-bottom-line-l,
				.cover-bottom-line-r { display: none; }
				.cover-wordmark {
					@include cover-cobrand-logo;
					background-position: left center;
					top: 524px;
					left: 88px;
					right: 524px;
					width: auto;
					height: 36px;
				}
			}
		}
		&.shinhan .cover-main .cover-wordmark { background-image: url(../assets/partner/cobrand-shinhan-white.png); }
		&.daishin .cover-main .cover-wordmark { background-image: url(../assets/partner/cobrand-daishin-white.png); }
	}

	// ===== Variant 05: Boutique Advisory (플랫 burgundy + floating 카드 + 하단 cream 스트립) =====
	&.cover-05 {
		background: #8f2b32;
		color: #f4e6d4;

		.cover-top-band {
			position: absolute;
			top: 82px;
			left: 75px;
			right: 75px;
			height: 60px;
			background: #a63a40;
			z-index: 2;
		}

		.cover-top-outer {
			position: absolute;
			top: 82px;
			left: 99px;
			right: 99px;
			height: 60px;
			z-index: 6;

			.cover-top-row {
				position: absolute;
				top: 22px;
				left: 0;
				right: 0;
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 24px;

				.cover-caption {
					color: #fbfaf5;
					font-size: 12px;
					letter-spacing: 0.38em;
					line-height: 1;
					font-weight: 500;
				}
				.cover-wordmark--top {
					width: 96px;
					height: 22px;
					background-image: url(../assets/images/weonus_wordmark_wh.png);
					background-repeat: no-repeat;
					background-position: center;
					background-size: contain;
				}
			}

			.cover-top-line {
				position: absolute;
				bottom: 0;
				left: 0;
				right: 0;
				height: 1px;
				background: rgba(250, 244, 235, 0.5);
			}
		}

		.cover-bg {
			position: absolute;
			top: 78px;
			left: 71px;
			right: 71px;
			bottom: 150px;
			overflow: hidden;
			background: #8f2b32;
			// 액자 — 상/좌/우만 shadow (bottom shadow 제거 — cream strip 오염 방지)
			box-shadow:
				0 -24px 48px rgba(0, 0, 0, 0.32),
				-24px 0 48px rgba(0, 0, 0, 0.28),
				24px 0 48px rgba(0, 0, 0, 0.28);
			z-index: 1;

			.cover-photo {
				position: absolute;
				top: 64px;
				left: 0;
				right: 0;
				bottom: 0;
				width: 100%;
				height: calc(100% - 64px);
				object-fit: cover;
				display: block;
				filter: grayscale(100%) contrast(1.08) brightness(1.02) sepia(0.15);
			}
			.cover-bg-tint {
				position: absolute;
				inset: 0;
				background: linear-gradient(
					180deg,
					rgba(110, 26, 32, 0.12) 0%,
					rgba(110, 26, 32, 0.15) 40%,
					rgba(110, 26, 32, 0.6) 70%,
					rgba(90, 18, 24, 0.92) 100%
				);
				mix-blend-mode: multiply;
				pointer-events: none;
			}
			.cover-bg-scrim {
				position: absolute;
				inset: 0;
				background: linear-gradient(180deg, rgba(52, 12, 18, 0.0) 70%, rgba(52, 12, 18, 0.38) 100%);
				pointer-events: none;
			}
		}

		.cover-cream-band {
			position: absolute;
			top: 670px;
			left: 71px;
			right: 71px;
			height: 95px;
			background: #fbfaf5;
			z-index: 3;

			// disclaimer — cream band 내부 빨간 글자 (테두리 제거 + 크기 확대)
			.cover-disclaimer {
				position: absolute;
				top: 8px;
				left: 24px;
				right: 24px;
				bottom: 8px;
				padding: 0;
				border: none;
				color: #9c252f;
				font-size: 13px;
				line-height: 1.5;
				letter-spacing: 0.005em;
				word-break: keep-all;
				word-spacing: 0.08em;
				display: flex;
				align-items: center;
			}
		}

		// 좌측 카드 — card bottom = cream-band top (touching, 같은 색 #fbfaf5 로 seamless)
		.cover-card {
			position: absolute;
			left: 130px;
			top: 247px;
			width: 457px;
			// bottom exactly at strip top (670) — top 247 + height 423 = 670
			height: 423px;
			box-sizing: border-box;
			padding: 48px 40px 28px;
			background: #fbfaf5;
			box-shadow:
				-5px 0 20px rgba(0, 0, 0, 0.22),
				0 -4px 20px rgba(0, 0, 0, 0.18),
				5px 0 20px rgba(0, 0, 0, 0.18);
			clip-path: inset(-30px -30px 0 -30px);
			display: flex;
			flex-direction: column;
			z-index: 7;

			// 내부 matte 외곽선 — 레퍼런스 기준 4면 1px hairline
			// top/left/right: #9e9e9e (ref ~#a0a0a0)
			// bottom: #cdcbc9 — ref 에서 카드-strip 경계 은은한 lighter gray
			// 14px inset on all sides — ref 에서 카드 가장자리로부터 안쪽
			&::before {
				content: '';
				position: absolute;
				top: 14px;
				left: 14px;
				right: 14px;
				bottom: 0;
				border-top: 1px solid #9e9e9e;
				border-left: 1px solid #9e9e9e;
				border-right: 1px solid #9e9e9e;
				border-bottom: 1px solid #cdcbc9;
				pointer-events: none;
				z-index: 2;
			}

			// 카드 중간 가로 divider — 레퍼런스 y=661(=285 CSS from card top)
			// title/addr 구역과 wordmark 구역을 나누는 hairline
			&::after {
				content: '';
				position: absolute;
				top: 285px;
				left: 14px;
				right: 14px;
				height: 1px;
				background: #9e9e9e;
				pointer-events: none;
				z-index: 2;
			}

			.cover-title {
				font-size: 46px;
				color: #9c252f;
				margin: 0 0 22px;
				line-height: 1.12;
				letter-spacing: -0.005em;
				font-weight: 800;
			}
			.cover-addr {
				display: flex;
				align-items: center;
				gap: 7px;
				color: #6b6761;
				font-size: 12px;
				letter-spacing: 0.03em;

				.pin-icon {
					flex: 0 0 auto;
					color: #9c252f;
					margin-top: -2px;
				}
			}
			// wordmark + 우측 수평선 (레퍼런스: 로고 옆으로 가는 선)
			.cover-card-footer {
				margin-top: auto;
				margin-bottom: 16px;
				display: flex;
				align-items: center;
				gap: 14px;
				min-height: 24px;

				.cover-wordmark {
					flex: 0 0 auto;
					width: 118px;
					height: 24px;
				}
				.cover-card-divider {
					flex: 1 1 auto;
					height: 1px;
					background: rgba(156, 37, 47, 0.32);
				}
			}
		}
		// 제휴 게스트 공동로고 — 흰 카드 위 footer → 컬러(투명배경) 로고, 받침 없음. divider 숨김.
		&.shinhan,
		&.daishin {
			.cover-card-footer {
				.cover-card-divider { display: none; }
				.cover-wordmark {
					@include cover-cobrand-logo;
					background-position: center;
					width: 300px;
					height: 32px;
					margin: 0 auto;
				}
			}
		}
		&.shinhan .cover-card-footer .cover-wordmark { background-image: url(../assets/partner/cobrand-shinhan-color.png); }
		&.daishin .cover-card-footer .cover-wordmark { background-image: url(../assets/partner/cobrand-daishin-color.png); }
	}
}

/* =========================================================
 * cover-variant-picker (좌측 툴바 내부, 출력 버튼 위)
 * ========================================================= */
.cover-variant-picker {
	display: flex;
	flex-wrap: wrap;
	gap: 10px 16px;
	align-items: center;
	padding: 10px 12px;
	margin-top: 12px;
	background: #f8f8f8;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 13px;

	.label {
		font-weight: 600;
		color: #333;
	}
	label {
		display: inline-flex;
		gap: 4px;
		align-items: center;
		cursor: pointer;
		margin: 0;
	}
	input[type='radio'] {
		margin: 0;
	}
}

.estimate-control { padding: 0 4px; }
.estimate-control .estimate-edit { display: flex; flex-direction: column; gap: 6px; margin-top: 8px; }
.estimate-control .estimate-edit label { display: flex; flex-direction: column; font-size: 12px; gap: 2px; }

@media print {
	.no-print,
	.cover-variant-picker {
		display: none !important;
	}
}
</style>
